import React, { useEffect, useState, useRef } from "react";
import { Constants, Images } from "../../config";
import { StyleSheet, View } from "react-native-web";
import { useTranslation } from "react-i18next";
import { StatusBar } from "../../components/atoms";
import {
  ArtistDao,
  CategoryDao,
  EventDao,
  FestivalDao,
  VenueDao,
} from "../../DAO";
import {
  CardList,
  LocationModal,
  SingleSelectModal,
} from "../../components/molecules";
import range from "lodash/range";
import reverse from "lodash/reverse";
import uniqBy from "lodash/uniqBy";
import { useRouter } from "next/router";
import moment from "moment";
import { LocationDao } from "../../DAO";
import PopularListSectionContainer from "../home/containers/PopularListSectionContainer";
import TrendingListSectionContainer from "../home/containers/TrendingListSectionContainer";
import RecommendedListSectionContainer from "../home/containers/RecommendedListSectionContainer";
import Link from "next/link";
import useDropdownMenu from "react-accessible-dropdown-menu-hook";
import { getClass } from "../../helpers/formatHelpers";

// 320px is filter, 32px-35px-32px are paddings
const contentWidth = "w-[calc(100vw-320px-32px-35px-32px)]";
const ExploreSearchScreen = (props) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { id: combinationLinkID } = router?.query || {};

  const isEnabledInfiniteScroll = false;

  const {
    buttonProps: buttonPropsPage,
    itemProps: itemPropsPage,
    isOpen: isOpenPage,
    setIsOpen: setIsOpenPage,
  } = useDropdownMenu(1);
  const pageSizeFestival = 24;
  const pageSizeEvent = 24;
  const pageSizeArtist = 36;
  const pageSizeVenue = 36;
  const pageSizeRooftop = 36;
  const pageSizeSpa = 36;
  const pageSizeVenueBeachful = 36;
  const pageSizePrefabCompany = 36;
  const pageSizePrefabHome = 36;
  const pageSizeZoo = 36;
  const pageSizeAnimal = 36;
  const pageSizeParkful = 36;
  const pageSizeCasino = 36;
  const pageSizeCastle = 36;
  const pageSizeResort = 36;
  const pageSizeAparthotel = 36;
  const pageSizeVenueCocktail = 36;
  const pageScrollRef = useRef(null);

  const {
    countFestival,
    setCountFestival,
    countEvent,
    setCountEvent,
    countArtist,
    setCountArtist,
    countVenue,
    setCountVenue,
    countRooftop,
    setCountRooftop,
    countSpa,
    setCountSpa,
    countVenueBeachful,
    setCountVenueBeachful,
    countPrefabCompany,
    setCountPrefabCompany,
    countPrefabHome,
    setCountPrefabHome,
    countZoo,
    setCountZoo,
    countAnimal,
    setCountAnimal,
    countParkful,
    setCountParkful,
    countCasino,
    setCountCasino,
    countCastle,
    setCountCastle,
    countResort,
    setCountResort,
    countAparthotel,
    setCountAparthotel,
    countVenueCocktail,
    setCountVenueCocktail,
    general,
    passViewMode,
    keyword,
    setKeyword,
    dataCategory,
    setDataCategory,
    locationSelected,
    setLocationSelected,
    setLocationSelectedTemp,
    sortBy,
    setSortBy,

    // Festival
    filterCriteriaListOriginalFestival,
    setFilterCriteriaListOriginalFestival,
    setFilterCriteriaListOriginalFestivalTemp,
    filterCriteriaListSelectedFestival,
    setFilterCriteriaListSelectedFestival,
    setFilterCriteriaListSelectedFestivalTemp,
    filterTabSelectedFestival,
    setFilterTabSelectedFestival,

    // Event
    filterCriteriaListOriginalEvent,
    setFilterCriteriaListOriginalEvent,
    setFilterCriteriaListOriginalEventTemp,
    filterCriteriaListSelectedEvent,
    setFilterCriteriaListSelectedEvent,
    setFilterCriteriaListSelectedEventTemp,
    filterTabSelectedEvent,
    setFilterTabSelectedEvent,

    // Artist
    filterCriteriaListOriginalArtist,
    setFilterCriteriaListOriginalArtist,
    setFilterCriteriaListOriginalArtistTemp,
    filterCriteriaListSelectedArtist,
    setFilterCriteriaListSelectedArtist,
    setFilterCriteriaListSelectedArtistTemp,
    filterTabSelectedArtist,
    setFilterTabSelectedArtist,

    // Venue
    filterCriteriaListOriginalVenue,
    setFilterCriteriaListOriginalVenue,
    setFilterCriteriaListOriginalVenueTemp,
    filterCriteriaListSelectedVenue,
    setFilterCriteriaListSelectedVenue,
    setFilterCriteriaListSelectedVenueTemp,
    filterTabSelectedVenue,
    setFilterTabSelectedVenue,

    // Rooftop
    filterCriteriaListOriginalRooftop,
    setFilterCriteriaListOriginalRooftop,
    setFilterCriteriaListOriginalRooftopTemp,
    filterCriteriaListSelectedRooftop,
    setFilterCriteriaListSelectedRooftop,
    setFilterCriteriaListSelectedRooftopTemp,
    filterTabSelectedRooftop,
    setFilterTabSelectedRooftop,

    // Spa
    filterCriteriaListOriginalSpa,
    setFilterCriteriaListOriginalSpa,
    setFilterCriteriaListOriginalSpaTemp,
    filterCriteriaListSelectedSpa,
    setFilterCriteriaListSelectedSpa,
    setFilterCriteriaListSelectedSpaTemp,
    filterTabSelectedSpa,
    setFilterTabSelectedSpa,

    // VenueBeachful
    filterCriteriaListOriginalVenueBeachful,
    setFilterCriteriaListOriginalVenueBeachful,
    setFilterCriteriaListOriginalVenueBeachfulTemp,
    filterCriteriaListSelectedVenueBeachful,
    setFilterCriteriaListSelectedVenueBeachful,
    setFilterCriteriaListSelectedVenueBeachfulTemp,
    filterTabSelectedVenueBeachful,
    setFilterTabSelectedVenueBeachful,

    // PrefabCompany
    filterCriteriaListOriginalPrefabCompany,
    setFilterCriteriaListOriginalPrefabCompany,
    setFilterCriteriaListOriginalPrefabCompanyTemp,
    filterCriteriaListSelectedPrefabCompany,
    setFilterCriteriaListSelectedPrefabCompany,
    setFilterCriteriaListSelectedPrefabCompanyTemp,
    filterTabSelectedPrefabCompany,
    setFilterTabSelectedPrefabCompany,

    // PrefabHome
    filterCriteriaListOriginalPrefabHome,
    setFilterCriteriaListOriginalPrefabHome,
    setFilterCriteriaListOriginalPrefabHomeTemp,
    filterCriteriaListSelectedPrefabHome,
    setFilterCriteriaListSelectedPrefabHome,
    setFilterCriteriaListSelectedPrefabHomeTemp,
    filterTabSelectedPrefabHome,
    setFilterTabSelectedPrefabHome,

    // Zoo
    filterCriteriaListOriginalZoo,
    setFilterCriteriaListOriginalZoo,
    setFilterCriteriaListOriginalZooTemp,
    filterCriteriaListSelectedZoo,
    setFilterCriteriaListSelectedZoo,
    setFilterCriteriaListSelectedZooTemp,
    filterTabSelectedZoo,
    setFilterTabSelectedZoo,

    // Animal
    filterCriteriaListOriginalAnimal,
    setFilterCriteriaListOriginalAnimal,
    setFilterCriteriaListOriginalAnimalTemp,
    filterCriteriaListSelectedAnimal,
    setFilterCriteriaListSelectedAnimal,
    setFilterCriteriaListSelectedAnimalTemp,
    filterTabSelectedAnimal,
    setFilterTabSelectedAnimal,

    // Parkful
    filterCriteriaListOriginalParkful,
    setFilterCriteriaListOriginalParkful,
    setFilterCriteriaListOriginalParkfulTemp,
    filterCriteriaListSelectedParkful,
    setFilterCriteriaListSelectedParkful,
    setFilterCriteriaListSelectedParkfulTemp,
    filterTabSelectedParkful,
    setFilterTabSelectedParkful,

    // Casino
    filterCriteriaListOriginalCasino,
    setFilterCriteriaListOriginalCasino,
    setFilterCriteriaListOriginalCasinoTemp,
    filterCriteriaListSelectedCasino,
    setFilterCriteriaListSelectedCasino,
    setFilterCriteriaListSelectedCasinoTemp,
    filterTabSelectedCasino,
    setFilterTabSelectedCasino,

    // Castle
    filterCriteriaListOriginalCastle,
    setFilterCriteriaListOriginalCastle,
    setFilterCriteriaListOriginalCastleTemp,
    filterCriteriaListSelectedCastle,
    setFilterCriteriaListSelectedCastle,
    setFilterCriteriaListSelectedCastleTemp,
    filterTabSelectedCastle,
    setFilterTabSelectedCastle,

    // Resort
    filterCriteriaListOriginalResort,
    setFilterCriteriaListOriginalResort,
    setFilterCriteriaListOriginalResortTemp,
    filterCriteriaListSelectedResort,
    setFilterCriteriaListSelectedResort,
    setFilterCriteriaListSelectedResortTemp,
    filterTabSelectedResort,
    setFilterTabSelectedResort,

    // Aparthotel
    filterCriteriaListOriginalAparthotel,
    setFilterCriteriaListOriginalAparthotel,
    setFilterCriteriaListOriginalAparthotelTemp,
    filterCriteriaListSelectedAparthotel,
    setFilterCriteriaListSelectedAparthotel,
    setFilterCriteriaListSelectedAparthotelTemp,
    filterTabSelectedAparthotel,
    setFilterTabSelectedAparthotel,

    // VenueCocktail
    filterCriteriaListOriginalVenueCocktail,
    setFilterCriteriaListOriginalVenueCocktail,
    setFilterCriteriaListOriginalVenueCocktailTemp,
    filterCriteriaListSelectedVenueCocktail,
    setFilterCriteriaListSelectedVenueCocktail,
    setFilterCriteriaListSelectedVenueCocktailTemp,
    filterTabSelectedVenueCocktail,
    setFilterTabSelectedVenueCocktail,

    currentPageIndex,
    setListFestival,
    setListEvent,
    setListVenue,
    setListRooftop,
    setListSpa,
    setListVenueBeachful,
    setListPrefabCompany,
    setListPrefabHome,
    setListZoo,
    setListAnimal,
    setListParkful,
    setListCasino,
    setListCastle,
    setListResort,
    setListAparthotel,
    setListVenueCocktail,
    isMobileVersion,
    isChartsMode,

    listFestival,
    listEvent,
    listVenue,
    listRooftop,
    listSpa,
    listVenueBeachful,
    listPrefabCompany,
    listPrefabHome,
    listZoo,
    listAnimal,
    listParkful,
    listCasino,
    listCastle,
    listResort,
    listAparthotel,
    listVenueCocktail,
  } = props;
  var isInitialized = false;
  const locationModal = useRef(null);

  // Festival
  const [pageIndexFestival, setPageIndexFestival] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingFestival, setIsLoadingFestival] = useState(false);
  const [isLoadingNextPageFestival, setIsLoadingNextPageFestival] =
    useState(false);
  const [itemsFestival, setItemsFestival] = useState(listFestival || []);
  const [isNoMoreDataFestival, setIsNoMoreDataFestival] = useState(false);

  // Event
  const [pageIndexEvent, setPageIndexEvent] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingEvent, setIsLoadingEvent] = useState(false);
  const [isLoadingNextPageEvent, setIsLoadingNextPageEvent] = useState(false);
  const [itemsEvent, setItemsEvent] = useState(listEvent || []);
  const [isNoMoreDataEvent, setIsNoMoreDataEvent] = useState(false);

  // Artist
  const [pageIndexArtist, setPageIndexArtist] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingArtist, setIsLoadingArtist] = useState(false);
  const [isLoadingNextPageArtist, setIsLoadingNextPageArtist] = useState(false);
  const [itemsArtist, setItemsArtist] = useState([]);
  const [isNoMoreDataArtist, setIsNoMoreDataArtist] = useState(false);

  // Venue
  const [pageIndexVenue, setPageIndexVenue] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingVenue, setIsLoadingVenue] = useState(false);
  const [isLoadingNextPageVenue, setIsLoadingNextPageVenue] = useState(false);
  const [itemsVenue, setItemsVenue] = useState(listVenue || []);
  const [isNoMoreDataVenue, setIsNoMoreDataVenue] = useState(false);

  // Rooftop
  const [pageIndexRooftop, setPageIndexRooftop] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingRooftop, setIsLoadingRooftop] = useState(false);
  const [isLoadingNextPageRooftop, setIsLoadingNextPageRooftop] =
    useState(false);
  const [itemsRooftop, setItemsRooftop] = useState(listRooftop || []);
  const [isNoMoreDataRooftop, setIsNoMoreDataRooftop] = useState(false);

  // Spa
  const [pageIndexSpa, setPageIndexSpa] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingSpa, setIsLoadingSpa] = useState(false);
  const [isLoadingNextPageSpa, setIsLoadingNextPageSpa] = useState(false);
  const [itemsSpa, setItemsSpa] = useState(listSpa || []);
  const [isNoMoreDataSpa, setIsNoMoreDataSpa] = useState(false);

  // VenueBeachful
  const [pageIndexVenueBeachful, setPageIndexVenueBeachful] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingVenueBeachful, setIsLoadingVenueBeachful] = useState(false);
  const [isLoadingNextPageVenueBeachful, setIsLoadingNextPageVenueBeachful] =
    useState(false);
  const [itemsVenueBeachful, setItemsVenueBeachful] = useState(
    listVenueBeachful || []
  );
  const [isNoMoreDataVenueBeachful, setIsNoMoreDataVenueBeachful] =
    useState(false);

  // PrefabCompany
  const [pageIndexPrefabCompany, setPageIndexPrefabCompany] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingPrefabCompany, setIsLoadingPrefabCompany] = useState(false);
  const [isLoadingNextPagePrefabCompany, setIsLoadingNextPagePrefabCompany] =
    useState(false);
  const [itemsPrefabCompany, setItemsPrefabCompany] = useState(
    listPrefabCompany || []
  );
  const [isNoMoreDataPrefabCompany, setIsNoMoreDataPrefabCompany] =
    useState(false);

  // PrefabHome
  const [pageIndexPrefabHome, setPageIndexPrefabHome] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingPrefabHome, setIsLoadingPrefabHome] = useState(false);
  const [isLoadingNextPagePrefabHome, setIsLoadingNextPagePrefabHome] =
    useState(false);
  const [itemsPrefabHome, setItemsPrefabHome] = useState(listPrefabHome || []);
  const [isNoMoreDataPrefabHome, setIsNoMoreDataPrefabHome] = useState(false);

  // Zoo
  const [pageIndexZoo, setPageIndexZoo] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingZoo, setIsLoadingZoo] = useState(false);
  const [isLoadingNextPageZoo, setIsLoadingNextPageZoo] = useState(false);
  const [itemsZoo, setItemsZoo] = useState(listZoo || []);
  const [isNoMoreDataZoo, setIsNoMoreDataZoo] = useState(false);

  // Animal
  const [pageIndexAnimal, setPageIndexAnimal] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingAnimal, setIsLoadingAnimal] = useState(false);
  const [isLoadingNextPageAnimal, setIsLoadingNextPageAnimal] = useState(false);
  const [itemsAnimal, setItemsAnimal] = useState(listAnimal || []);
  const [isNoMoreDataAnimal, setIsNoMoreDataAnimal] = useState(false);

  // Parkful
  const [pageIndexParkful, setPageIndexParkful] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingParkful, setIsLoadingParkful] = useState(false);
  const [isLoadingNextPageParkful, setIsLoadingNextPageParkful] =
    useState(false);
  const [itemsParkful, setItemsParkful] = useState(listParkful || []);
  const [isNoMoreDataParkful, setIsNoMoreDataParkful] = useState(false);

  // Casino
  const [pageIndexCasino, setPageIndexCasino] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingCasino, setIsLoadingCasino] = useState(false);
  const [isLoadingNextPageCasino, setIsLoadingNextPageCasino] = useState(false);
  const [itemsCasino, setItemsCasino] = useState(listCasino || []);
  const [isNoMoreDataCasino, setIsNoMoreDataCasino] = useState(false);

  // Castle
  const [pageIndexCastle, setPageIndexCastle] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingCastle, setIsLoadingCastle] = useState(false);
  const [isLoadingNextPageCastle, setIsLoadingNextPageCastle] = useState(false);
  const [itemsCastle, setItemsCastle] = useState(listCastle || []);
  const [isNoMoreDataCastle, setIsNoMoreDataCastle] = useState(false);

  // Resort
  const [pageIndexResort, setPageIndexResort] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingResort, setIsLoadingResort] = useState(false);
  const [isLoadingNextPageResort, setIsLoadingNextPageResort] = useState(false);
  const [itemsResort, setItemsResort] = useState(listResort || []);
  const [isNoMoreDataResort, setIsNoMoreDataResort] = useState(false);

  // Aparthotel
  const [pageIndexAparthotel, setPageIndexAparthotel] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingAparthotel, setIsLoadingAparthotel] = useState(false);
  const [isLoadingNextPageAparthotel, setIsLoadingNextPageAparthotel] =
    useState(false);
  const [itemsAparthotel, setItemsAparthotel] = useState(listAparthotel || []);
  const [isNoMoreDataAparthotel, setIsNoMoreDataAparthotel] = useState(false);

  // Venue Cocktail
  const [pageIndexVenueCocktail, setPageIndexVenueCocktail] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingVenueCocktail, setIsLoadingVenueCocktail] = useState(false);
  const [isLoadingNextPageVenueCocktail, setIsLoadingNextPageVenueCocktail] =
    useState(false);
  const [itemsVenueCocktail, setItemsVenueCocktail] = useState(
    listVenueCocktail || []
  );
  const [isNoMoreDataVenueCocktail, setIsNoMoreDataVenueCocktail] =
    useState(false);

  // Other
  const [pageIndexOther, setPageIndexOther] = useState(
    parseInt(currentPageIndex) || 1
  );
  const [isLoadingOther, setIsLoadingOther] = useState(false);
  const [isLoadingNextPageOther, setIsLoadingNextPageOther] = useState(false);
  const [itemsOther, setItemsOther] = useState([]);
  const [isNoMoreDataOther, setIsNoMoreDataOther] = useState(false);

  const [categoryList, setCategoryList] = useState([]);
  const [itemSelected, setItemSelected] = useState(null);

  const followModal = useRef(null);
  const sortMenuModal = useRef(null);
  const sortMenu = [
    {
      id: Constants.sortByAction.SORT_BY_POPULARITY,
      label: t("key_sort_option_popularity"),
      isHide:
        dataCategory === Constants.categoryType.CATEGORY_VENUE ||
        dataCategory === Constants.categoryType.CATEGORY_ROOFTOP ||
        dataCategory === Constants.categoryType.CATEGORY_SPA ||
        dataCategory === Constants.categoryType.CATEGORY_VENUE_BEACHFUL ||
        dataCategory === Constants.categoryType.CATEGORY_PREFAB_COMPANY ||
        dataCategory === Constants.categoryType.CATEGORY_PREFAB_HOMES ||
        dataCategory === Constants.categoryType.CATEGORY_ZOO ||
        dataCategory === Constants.categoryType.CATEGORY_ANIMAL ||
        dataCategory === Constants.categoryType.CATEGORY_PARKFUL ||
        dataCategory === Constants.categoryType.CATEGORY_CASINO ||
        dataCategory === Constants.categoryType.CATEGORY_CASTLE ||
        dataCategory === Constants.categoryType.CATEGORY_RESORT ||
        dataCategory === Constants.categoryType.CATEGORY_APARTHOTEL ||
        dataCategory === Constants.categoryType.CATEGORY_VENUE_COCKTAIL,
    },
    {
      id: Constants.sortByAction.SORT_BY_RECOMMENDED,
      label: t("key_sort_option_recommended"),
      isHide:
        dataCategory !== Constants.categoryType.CATEGORY_VENUE &&
        dataCategory !== Constants.categoryType.CATEGORY_ROOFTOP &&
        dataCategory !== Constants.categoryType.CATEGORY_SPA &&
        dataCategory !== Constants.categoryType.CATEGORY_VENUE_BEACHFUL &&
        dataCategory !== Constants.categoryType.CATEGORY_PREFAB_COMPANY &&
        dataCategory !== Constants.categoryType.CATEGORY_PREFAB_HOMES &&
        dataCategory !== Constants.categoryType.CATEGORY_ZOO &&
        dataCategory !== Constants.categoryType.CATEGORY_ANIMAL &&
        dataCategory !== Constants.categoryType.CATEGORY_PARKFUL &&
        dataCategory !== Constants.categoryType.CATEGORY_CASINO &&
        dataCategory !== Constants.categoryType.CATEGORY_CASTLE &&
        dataCategory !== Constants.categoryType.CATEGORY_RESORT &&
        dataCategory !== Constants.categoryType.CATEGORY_APARTHOTEL &&
        dataCategory !== Constants.categoryType.CATEGORY_VENUE_COCKTAIL,
    },
    {
      id: Constants.sortByAction.SORT_BY_TRENDING,
      label: t("key_sort_option_trending"),
      isHide: false,
    },
    {
      id: Constants.sortByAction.SORT_BY_PRICE_LOW,
      label: t("key_sort_option_price"),
      suffix: t("key_sort_option_low_high"),
      isHide:
        dataCategory === Constants.categoryType.CATEGORY_ARTIST ||
        dataCategory === Constants.categoryType.CATEGORY_PROMOTERS ||
        dataCategory === Constants.categoryType.CATEGORY_OTHER,
    },
    {
      id: Constants.sortByAction.SORT_BY_PRICE_HIGH,
      label: t("key_sort_option_price"),
      suffix: t("key_sort_option_high_low"),
      isHide:
        dataCategory === Constants.categoryType.CATEGORY_ARTIST ||
        dataCategory === Constants.categoryType.CATEGORY_PROMOTERS ||
        dataCategory === Constants.categoryType.CATEGORY_OTHER,
    },
    // {
    //   id: Constants.sortByAction.SORT_BY_RATING_LOW,
    //   label: t("key_sort_option_rating"),
    //   suffix: t("key_sort_option_low_high"),
    //   isHide: dataCategory === Constants.categoryType.CATEGORY_OTHER,
    // },
    // {
    //   id: Constants.sortByAction.SORT_BY_RATING_HIGH,
    //   label: t("key_sort_option_rating"),
    //   suffix: t("key_sort_option_high_low"),
    //   isHide: dataCategory === Constants.categoryType.CATEGORY_OTHER,
    // },
    {
      id: Constants.sortByAction.SORT_BY_NAMEATOZ,
      label: t("key_sort_option_name"),
      suffix: t("key_sort_option_a_z"),
      isHide: false,
    },
    {
      id: Constants.sortByAction.SORT_BY_NAMEZTOA,
      label: t("key_sort_option_name"),
      suffix: t("key_sort_option_z_a"),
      isHide: false,
    },
  ];

  const combinationLink = () => {
    return new Promise((resolve, reject) => {
      LocationDao.find({ pageSize: 999, isCountryOnly: 1 }).then(
        (locations) => {
          if (dataCategory == Constants.categoryType.CATEGORY_FESTIVAL) {
            const charSet = [
              locations.map((i) => i.name || i.country_name),
              filterCriteriaListOriginalFestival
                ?.find((i) => i.title === "Date")
                ?.detailList?.map((i) => i.label),
              filterCriteriaListOriginalFestival
                ?.find((i) => i.title === "Music")
                ?.detailList?.map((i) => i.label),
              filterCriteriaListOriginalFestival
                ?.find((i) => i.title === "Category")
                ?.detailList?.map((i) => i.label),
            ];
            const result = charSet.reduce(
              (a, b) => a.flatMap((x) => b.map((y) => x + (x ? "," : "") + y)),
              [""]
            );

            resolve({ combinationLinks: result, locations });
          } else {
            const charSet = [
              locations.map((i) => i.name || i.country_name),
              filterCriteriaListOriginalArtist
                ?.find((i) => i.title === "Date")
                ?.detailList?.map((i) => i.label),
              filterCriteriaListOriginalArtist
                ?.find((i) => i.title === "Music")
                ?.detailList?.map((i) => i.label),
              filterCriteriaListOriginalArtist
                ?.find((i) => i.title === "Category")
                ?.detailList?.map((i) => i.label),
            ];
            const result = charSet.reduce(
              (a, b) => a.flatMap((x) => b.map((y) => x + (x ? "," : "") + y)),
              [""]
            );

            resolve({ combinationLinks: result, locations });
          }
        }
      );
    });
  };

  const getCombinationLink = async () => {
    if (dataCategory == Constants.categoryType.CATEGORY_FESTIVAL) {
      const { combinationLinks, locations } = await combinationLink();
      const locationSelectedLabel =
        locationSelected?.name || locationSelected?.country_name;
      const dateSelectedLabel = filterCriteriaListSelectedFestival[0];
      const musicSelectedLabel = filterCriteriaListOriginalFestival
        ?.find((i) => i.title === "Music")
        ?.detailList?.find(
          (i) => i.tagId === filterCriteriaListSelectedFestival[1]
        )?.label;
      const categorySelectedLabel = filterCriteriaListOriginalFestival
        ?.find((i) => i.title === "Category")
        ?.detailList?.find(
          (i) => i.tagId === filterCriteriaListSelectedFestival[2]
        )?.label;
      let result = combinationLinks?.findIndex(
        (i) =>
          i ===
          `${locationSelectedLabel},${dateSelectedLabel},${musicSelectedLabel},${categorySelectedLabel}`
      );

      router.replace({
        query: {
          ...router.query,
          category: "festivals",
          id: result,
          page: currentPageIndex,
        },
      });
    } else {
      const { combinationLinks, locations } = await combinationLink();
      const locationSelectedLabel =
        locationSelected?.name || locationSelected?.country_name;
      const dateSelectedLabel = filterCriteriaListSelectedArtist[0];
      const musicSelectedLabel = filterCriteriaListOriginalArtist
        ?.find((i) => i.title === "Music")
        ?.detailList?.find(
          (i) => i.tagId === filterCriteriaListSelectedArtist[1]
        )?.label;
      const categorySelectedLabel = filterCriteriaListOriginalArtist
        ?.find((i) => i.title === "Category")
        ?.detailList?.find(
          (i) => i.tagId === filterCriteriaListSelectedArtist[2]
        )?.label;
      let result = combinationLinks?.findIndex(
        (i) =>
          i ===
          `${locationSelectedLabel},${dateSelectedLabel},${musicSelectedLabel},${categorySelectedLabel}`
      );

      router.replace({
        query: {
          ...router.query,
          category: "artists",
          id: result,
          page: currentPageIndex,
        },
      });
    }
  };

  const getInitialCombinationLink = async () => {
    const { combinationLinks, locations } = await combinationLink();
    const combinationSelected =
      combinationLinks[parseInt(combinationLinkID)]?.split(",");
    if (!combinationSelected || combinationSelected?.length <= 0) {
      return false;
    }
    setLocationSelected(
      locations?.find(
        (i) =>
          i.name === combinationSelected[0] ||
          i.country_name === combinationSelected[0]
      )
    );
    setLocationSelectedTemp(
      locations?.find(
        (i) =>
          i.name === combinationSelected[0] ||
          i.country_name === combinationSelected[0]
      )
    );
    if (dataCategory == Constants.categoryType.CATEGORY_FESTIVAL) {
      const filterSelected = [
        combinationSelected[1],
        filterCriteriaListOriginalFestival
          ?.find((i) => i.title === "Music")
          ?.detailList?.find((i) => i.label === combinationSelected[2])?.tagId,
        filterCriteriaListOriginalFestival
          ?.find((i) => i.title === "Category")
          ?.detailList?.find((i) => i.label === combinationSelected[3])?.tagId,
      ];
      setFilterCriteriaListSelectedFestival(filterSelected);
      setFilterCriteriaListSelectedFestivalTemp(filterSelected);

      const filterOriginal = filterCriteriaListOriginalFestival.map((item) => {
        if (item.title == "Date") {
          return {
            ...item,
            selectedList: [combinationSelected[1]],
          };
        }
        if (item.title == "Music") {
          return {
            ...item,
            selectedList: [
              filterCriteriaListOriginalFestival
                ?.find((i) => i.title === "Music")
                ?.detailList?.find((i) => i.label === combinationSelected[2])
                ?.tagId,
            ],
          };
        }
        if (item.title == "Category") {
          return {
            ...item,
            selectedList: [
              filterCriteriaListOriginalFestival
                ?.find((i) => i.title === "Category")
                ?.detailList?.find((i) => i.label === combinationSelected[3])
                ?.tagId,
            ],
          };
        }

        return item;
      });
      setFilterCriteriaListOriginalFestival(filterOriginal);
      setFilterCriteriaListOriginalFestivalTemp(filterOriginal);
    } else {
      const filterSelected = [
        combinationSelected[1],
        filterCriteriaListOriginalArtist
          ?.find((i) => i.title === "Music")
          ?.detailList?.find((i) => i.label === combinationSelected[2])?.tagId,
        filterCriteriaListOriginalArtist
          ?.find((i) => i.title === "Category")
          ?.detailList?.find((i) => i.label === combinationSelected[3])?.tagId,
      ];
      setFilterCriteriaListSelectedArtist(filterSelected);
      setFilterCriteriaListSelectedArtistTemp(filterSelected);

      const filterOriginal = filterCriteriaListOriginalArtist.map((item) => {
        if (item.title == "Date") {
          return {
            ...item,
            selectedList: [combinationSelected[1]],
          };
        }
        if (item.title == "Music") {
          return {
            ...item,
            selectedList: [
              filterCriteriaListOriginalArtist
                ?.find((i) => i.title === "Music")
                ?.detailList?.find((i) => i.label === combinationSelected[2])
                ?.tagId,
            ],
          };
        }
        if (item.title == "Category") {
          return {
            ...item,
            selectedList: [
              filterCriteriaListOriginalArtist
                ?.find((i) => i.title === "Category")
                ?.detailList?.find((i) => i.label === combinationSelected[3])
                ?.tagId,
            ],
          };
        }

        return item;
      });
      setFilterCriteriaListOriginalArtist(filterOriginal);
      setFilterCriteriaListOriginalArtistTemp(filterOriginal);
    }
  };

  useEffect(() => {
    if (isChartsMode) {
      setTimeout(() => {
        getInitialCombinationLink();
      }, 500);
    }
  }, [passViewMode]);

  const onLoad = () => {
    const _isInitialized = isInitialized;
    setIsOpenPage(false);
    CategoryDao.getConstantCategories().then((categories) => {
      const category = categories
        .filter(
          (item) =>
            item.id == Constants.categoryType.CATEGORY_ARTIST ||
            item.id == Constants.categoryType.CATEGORY_FESTIVAL ||
            item.id == Constants.categoryType.CATEGORY_EVENT ||
            item.id == Constants.categoryType.CATEGORY_VENUE ||
            item.id == Constants.categoryType.CATEGORY_ROOFTOP ||
            item.id == Constants.categoryType.CATEGORY_SPA ||
            item.id == Constants.categoryType.CATEGORY_VENUE_BEACHFUL ||
            item.id == Constants.categoryType.CATEGORY_PREFAB_COMPANY ||
            item.id == Constants.categoryType.CATEGORY_PREFAB_HOMES ||
            item.id == Constants.categoryType.CATEGORY_ZOO ||
            item.id == Constants.categoryType.CATEGORY_ANIMAL ||
            item.id == Constants.categoryType.CATEGORY_PARKFUL ||
            item.id == Constants.categoryType.CATEGORY_CASINO ||
            item.id == Constants.categoryType.CATEGORY_CASTLE ||
            item.id == Constants.categoryType.CATEGORY_RESORT ||
            item.id == Constants.categoryType.CATEGORY_APARTHOTEL ||
            item.id == Constants.categoryType.CATEGORY_VENUE_COCKTAIL ||
            item.id == Constants.categoryType.CATEGORY_OTHER
        )
        .map((item) => ({ ...item, count: 0 }));
      setCategoryList(category);
      if (!dataCategory && categories && categories.length > 0) {
        if (isInitialized) {
          setDataCategory(categories[0].id);
        }
      }

      if (isChartsMode) {
        getCombinationLink();
      }
      loadItems(false, category, !_isInitialized);
    });
    isInitialized = true;
  };

  const convertParamsFestival = (isNextPage, category) => {
    let status = [];
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let rating = null;
    let lineupSize = null;
    let price = null;
    let festivalGenreTagId = null;
    let sortByCharts = null;
    let isAnytime = null;
    if (filterCriteriaListOriginalFestival) {
      filterCriteriaListOriginalFestival.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isLineup) {
            lineupSize =
              item.selectedList?.length > 0 ? item.selectedList : null;
          } else if (item.isPrice && item.selectedList.length > 0) {
            price =
              item.selectedList[1] === 1000
                ? {
                    minValue: item.selectedList[0],
                  }
                : {
                    minValue: item.selectedList[0],
                    maxValue: item.selectedList[1],
                  };
          } else if (item.isRating && item.selectedList?.length > 0) {
            rating = item.selectedList;
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            status = item.selectedList;
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE,
                  tags: item.selectedList?.filter((i) => i > 700 && i < 800),
                });
              }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0) {
              festivalGenreTagId =
                item.selectedList[0] !== 300 ? item.selectedList[0] : null;
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      startDateFrom,
      startDateTo,
      isAnytime,
      keyword: keyword,
      festivalGenreTagId,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexFestival - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      pageSize: pageSizeFestival,
      status: status.length > 0 ? status : null,
      tagFilters,
      filterFollowLogic: filterTabSelectedFestival,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      sortType: sortByCharts || sortBy,
      rating,
      lineupSize,
      price,
    };
  };

  const convertParamsEvent = (isNextPage, category) => {
    let status = [];
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let rating = null;
    let lineupSize = null;
    let price = null;
    let festivalGenreTagId = null;
    let sortByCharts = null;
    let isAnytime = null;
    if (filterCriteriaListOriginalEvent) {
      filterCriteriaListOriginalEvent.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isLineup) {
            lineupSize =
              item.selectedList?.length > 0 ? item.selectedList : null;
          } else if (item.isPrice && item.selectedList.length > 0) {
            price =
              item.selectedList[1] === 1000
                ? {
                    minValue: item.selectedList[0],
                  }
                : {
                    minValue: item.selectedList[0],
                    maxValue: item.selectedList[1],
                  };
          } else if (item.isRating && item.selectedList?.length > 0) {
            rating = item.selectedList;
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            status = item.selectedList;
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE,
                  tags: item.selectedList?.filter((i) => i > 700 && i < 800),
                });
              }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0) {
              festivalGenreTagId =
                item.selectedList[0] !== 300 ? item.selectedList[0] : null;
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: Constants.categoryType.CATEGORY_EVENT,
      startDateFrom,
      startDateTo,
      isAnytime,
      keyword: keyword,
      festivalGenreTagId,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexEvent - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      pageSize: pageSizeEvent,
      status: status.length > 0 ? status : null,
      tagFilters,
      filterFollowLogic: filterTabSelectedEvent,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      sortType: sortByCharts || sortBy,
      rating,
      lineupSize,
      price,
    };
  };

  const getDataFestival = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataFestival) {
        return false;
      }
      setIsLoadingNextPageFestival(true);
    } else {
      setIsLoadingFestival(true);
      if (!isCountOnly) {
        setItemsFestival([]);
        setListFestival([]);
      }
    }
    const params = convertParamsFestival(isNextPage, category);
    FestivalDao.findWeb(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_FESTIVAL) {
          _category[index].count = result.totalCount;
          setCountFestival(result.totalCount);
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageFestival(false);
      setIsLoadingFestival(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexFestival((isNextPage ? pageIndexFestival : 1) + 1);
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsFestival(uniqBy(itemsFestival.concat(result.data), "id"));
          setListFestival(uniqBy(itemsFestival.concat(result.data), "id"));
        }
      } else {
        setItemsFestival(uniqBy(result.data, "id"));
        setListFestival(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataFestival(true);
      } else {
        setIsNoMoreDataFestival(false);
      }
    });
  };

  const getDataEvent = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataEvent) {
        return false;
      }
      setIsLoadingNextPageEvent(true);
    } else {
      setIsLoadingEvent(true);
      if (!isCountOnly) {
        setItemsEvent([]);
        setListEvent([]);
      }
    }
    const params = convertParamsEvent(isNextPage, category);
    EventDao.findWeb(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_EVENT) {
          _category[index].count = result.totalCount;
          setCountEvent(result.totalCount);
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageEvent(false);
      setIsLoadingEvent(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexEvent((isNextPage ? pageIndexEvent : 1) + 1);
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsEvent(uniqBy(itemsEvent.concat(result.data), "id"));
          setListEvent(uniqBy(itemsEvent.concat(result.data), "id"));
        }
      } else {
        setItemsEvent(uniqBy(result.data, "id"));
        setListEvent(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataEvent(true);
      } else {
        setIsNoMoreDataEvent(false);
      }
    });
  };

  const convertParamsArtist = (isNextPage, category) => {
    let tagFilters = [];
    let artistCountryId = null;
    let activity = null;
    let startDateFrom = null;
    let startDateTo = null;
    let eventSize = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    if (filterCriteriaListOriginalArtist) {
      filterCriteriaListOriginalArtist.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isEventSize) {
            eventSize =
              item.selectedList?.length > 0 ? item.selectedList : null;
          } else if (item.isLocation && item.selectedList.length > 0) {
            artistCountryId = item.selectedList;
          } else if (item.isActivity && item.selectedList.length > 0) {
            activity = item.selectedList;
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      startDateFrom,
      startDateTo,
      isAnytime,
      activity,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexArtist - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedArtist,
      pageSize: pageSizeArtist,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      artistCountryId,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
      eventSize,
    };
  };

  const getDataArtist = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataArtist) {
        return false;
      }
      setIsLoadingNextPageArtist(true);
    } else {
      setIsLoadingArtist(true);
      if (!isCountOnly) {
        setItemsArtist([]);
      }
    }
    const params = convertParamsArtist(isNextPage, category);
    ArtistDao.findWeb(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_ARTIST) {
          _category[index].count = result.totalCount;
          setCountArtist(result.totalCount);
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageArtist(false);
      setIsLoadingArtist(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexArtist((isNextPage ? pageIndexArtist : 1) + 1);
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsArtist(uniqBy(itemsArtist.concat(result.data), "id"));
        }
      } else {
        setItemsArtist(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataArtist(true);
      } else {
        setIsNoMoreDataArtist(false);
      }
    });
  };

  const convertParamsVenue = (isNextPage, category) => {
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    let venueStatus = null;
    if (filterCriteriaListOriginalVenue) {
      filterCriteriaListOriginalVenue.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE,
                  tags: item.selectedList?.filter((i) => i > 700 && i < 800),
                });
              }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      startDateFrom,
      startDateTo,
      isAnytime,
      venueStatus,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexVenue - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedVenue,
      pageSize: pageSizeVenue,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
    };
  };

  const getDataVenue = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataVenue) {
        return false;
      }
      setIsLoadingNextPageVenue(true);
    } else {
      setIsLoadingVenue(true);
      if (!isCountOnly) {
        setItemsVenue([]);
        setListVenue([]);
      }
    }
    const params = convertParamsVenue(isNextPage, category);
    VenueDao.find(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_VENUE) {
          _category[index].count = result.totalCount;
          if (setCountVenue) {
            setCountVenue(result.totalCount);
          }
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageVenue(false);
      setIsLoadingVenue(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexVenue((isNextPage ? pageIndexVenue : 1) + 1);
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsVenue(uniqBy(itemsVenue.concat(result.data), "id"));
          setListVenue(uniqBy(itemsVenue.concat(result.data), "id"));
        }
      } else {
        setItemsVenue(uniqBy(result.data, "id"));
        setListVenue(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataVenue(true);
      } else {
        setIsNoMoreDataVenue(false);
      }
    });
  };

  const convertParamsRooftop = (isNextPage, category) => {
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    let venueStatus = null;
    if (filterCriteriaListOriginalRooftop) {
      filterCriteriaListOriginalRooftop.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: Constants.categoryType.CATEGORY_ROOFTOP,
      startDateFrom,
      startDateTo,
      isAnytime,
      venueStatus,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexRooftop - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedRooftop,
      pageSize: pageSizeRooftop,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
    };
  };

  const getDataRooftop = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataRooftop) {
        return false;
      }
      setIsLoadingNextPageRooftop(true);
    } else {
      setIsLoadingRooftop(true);
      if (!isCountOnly) {
        setItemsRooftop([]);
        setListRooftop([]);
      }
    }
    const params = convertParamsRooftop(isNextPage, category);
    VenueDao.find(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_ROOFTOP) {
          _category[index].count = result.totalCount;
          if (setCountRooftop) {
            setCountRooftop(result.totalCount);
          }
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageRooftop(false);
      setIsLoadingRooftop(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexRooftop((isNextPage ? pageIndexRooftop : 1) + 1);
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsRooftop(uniqBy(itemsRooftop.concat(result.data), "id"));
          setListRooftop(uniqBy(itemsRooftop.concat(result.data), "id"));
        }
      } else {
        setItemsRooftop(uniqBy(result.data, "id"));
        setListRooftop(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataRooftop(true);
      } else {
        setIsNoMoreDataRooftop(false);
      }
    });
  };

  const convertParamsSpa = (isNextPage, category) => {
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    let venueStatus = null;
    let amenities = null;
    if (filterCriteriaListOriginalSpa) {
      filterCriteriaListOriginalSpa.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_AMENITIES) {
            if (item.selectedList.length > 0) {
              amenities = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: Constants.categoryType.CATEGORY_SPA,
      startDateFrom,
      startDateTo,
      isAnytime,
      venueStatus,
      amenities,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexSpa - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedSpa,
      pageSize: pageSizeSpa,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
    };
  };

  const getDataSpa = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataSpa) {
        return false;
      }
      setIsLoadingNextPageSpa(true);
    } else {
      setIsLoadingSpa(true);
      if (!isCountOnly) {
        setItemsSpa([]);
        setListSpa([]);
      }
    }
    const params = convertParamsSpa(isNextPage, category);
    VenueDao.find(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_SPA) {
          _category[index].count = result.totalCount;
          if (setCountSpa) {
            setCountSpa(result.totalCount);
          }
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageSpa(false);
      setIsLoadingSpa(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexSpa((isNextPage ? pageIndexSpa : 1) + 1);
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsSpa(uniqBy(itemsSpa.concat(result.data), "id"));
          setListSpa(uniqBy(itemsSpa.concat(result.data), "id"));
        }
      } else {
        setItemsSpa(uniqBy(result.data, "id"));
        setListSpa(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataSpa(true);
      } else {
        setIsNoMoreDataSpa(false);
      }
    });
  };

  const convertParamsVenueBeachful = (isNextPage, category) => {
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    let venueStatus = null;
    if (filterCriteriaListOriginalVenueBeachful) {
      filterCriteriaListOriginalVenueBeachful.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: Constants.categoryType.CATEGORY_VENUE_BEACHFUL,
      startDateFrom,
      startDateTo,
      isAnytime,
      venueStatus,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexVenueBeachful - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedVenueBeachful,
      pageSize: pageSizeVenueBeachful,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
    };
  };

  const getDataVenueBeachful = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataVenueBeachful) {
        return false;
      }
      setIsLoadingNextPageVenueBeachful(true);
    } else {
      setIsLoadingVenueBeachful(true);
      if (!isCountOnly) {
        setItemsVenueBeachful([]);
        setListVenueBeachful([]);
      }
    }
    const params = convertParamsVenueBeachful(isNextPage, category);
    VenueDao.find(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_VENUE_BEACHFUL) {
          _category[index].count = result.totalCount;
          if (setCountVenueBeachful) {
            setCountVenueBeachful(result.totalCount);
          }
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageVenueBeachful(false);
      setIsLoadingVenueBeachful(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexVenueBeachful(
          (isNextPage ? pageIndexVenueBeachful : 1) + 1
        );
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsVenueBeachful(
            uniqBy(itemsVenueBeachful.concat(result.data), "id")
          );
          setListVenueBeachful(
            uniqBy(itemsVenueBeachful.concat(result.data), "id")
          );
        }
      } else {
        setItemsVenueBeachful(uniqBy(result.data, "id"));
        setListVenueBeachful(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataVenueBeachful(true);
      } else {
        setIsNoMoreDataVenueBeachful(false);
      }
    });
  };

  const convertParamsPrefabCompany = (isNextPage, category) => {
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    let venueStatus = null;
    let companyHomeSize = null;
    if (filterCriteriaListOriginalPrefabCompany) {
      filterCriteriaListOriginalPrefabCompany.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else if (item.isCompanyHomeSize) {
            companyHomeSize =
              item.selectedList?.length > 0 ? item.selectedList : null;
          } else if (item.title == "Size") {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_SIZE_SQF,
                category: Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT,
                ...item.selectedList[0],
              });
            }
          } else if (item.title == "Price") {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_PRICE,
                category: Constants.tagCategory.TAG_CATEGORY_PRICE,
                ...item.selectedList[0],
              });
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: Constants.categoryType.CATEGORY_PREFAB_COMPANY,
      startDateFrom,
      startDateTo,
      isAnytime,
      venueStatus,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexPrefabCompany - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedPrefabCompany,
      pageSize: pageSizePrefabCompany,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
      companyHomeSize,
    };
  };

  const getDataPrefabCompany = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataPrefabCompany) {
        return false;
      }
      setIsLoadingNextPagePrefabCompany(true);
    } else {
      setIsLoadingPrefabCompany(true);
      if (!isCountOnly) {
        setItemsPrefabCompany([]);
        setListPrefabCompany([]);
      }
    }
    const params = convertParamsPrefabCompany(isNextPage, category);
    VenueDao.find(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_PREFAB_COMPANY) {
          _category[index].count = result.totalCount;
          if (setCountPrefabCompany) {
            setCountPrefabCompany(result.totalCount);
          }
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPagePrefabCompany(false);
      setIsLoadingPrefabCompany(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexPrefabCompany(
          (isNextPage ? pageIndexPrefabCompany : 1) + 1
        );
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsPrefabCompany(
            uniqBy(itemsPrefabCompany.concat(result.data), "id")
          );
          setListPrefabCompany(
            uniqBy(itemsPrefabCompany.concat(result.data), "id")
          );
        }
      } else {
        setItemsPrefabCompany(uniqBy(result.data, "id"));
        setListPrefabCompany(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataPrefabCompany(true);
      } else {
        setIsNoMoreDataPrefabCompany(false);
      }
    });
  };

  const convertParamsPrefabHome = (isNextPage, category) => {
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    let venueStatus = null;
    if (filterCriteriaListOriginalPrefabHome) {
      filterCriteriaListOriginalPrefabHome.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else if (item.title == "Size") {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_SIZE_SQF,
                category: Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT,
                ...item.selectedList[0],
              });
            }
          } else if (item.title == "Bathrooms") {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_BATHROOM,
                category: Constants.tagCategory.TAG_CATEGORY_PREFAB_BATHROOM,
                ...item.selectedList[0],
              });
            }
          } else if (item.title == "Price") {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_PRICE,
                category: Constants.tagCategory.TAG_CATEGORY_PRICE,
                ...item.selectedList[0],
              });
            }
          } else if (item.title == "Capacity") {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_CAPACITY,
                category: Constants.tagCategory.TAG_CATEGORY_PREFAB_CAPACITY,
                ...item.selectedList[0],
              });
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: Constants.categoryType.CATEGORY_PREFAB_HOMES,
      startDateFrom,
      startDateTo,
      isAnytime,
      venueStatus,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexPrefabHome - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedPrefabHome,
      pageSize: pageSizePrefabHome,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
    };
  };

  const getDataPrefabHome = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataPrefabHome) {
        return false;
      }
      setIsLoadingNextPagePrefabHome(true);
    } else {
      setIsLoadingPrefabHome(true);
      if (!isCountOnly) {
        setItemsPrefabHome([]);
        setListPrefabHome([]);
      }
    }
    const params = convertParamsPrefabHome(isNextPage, category);
    VenueDao.find(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_PREFAB_HOMES) {
          _category[index].count = result.totalCount;
          if (setCountPrefabHome) {
            setCountPrefabHome(result.totalCount);
          }
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPagePrefabHome(false);
      setIsLoadingPrefabHome(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexPrefabHome((isNextPage ? pageIndexPrefabHome : 1) + 1);
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsPrefabHome(uniqBy(itemsPrefabHome.concat(result.data), "id"));
          setListPrefabHome(uniqBy(itemsPrefabHome.concat(result.data), "id"));
        }
      } else {
        setItemsPrefabHome(uniqBy(result.data, "id"));
        setListPrefabHome(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataPrefabHome(true);
      } else {
        setIsNoMoreDataPrefabHome(false);
      }
    });
  };

  const convertParamsZoo = (isNextPage, category) => {
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    let venueStatus = null;
    if (filterCriteriaListOriginalZoo) {
      filterCriteriaListOriginalZoo.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else if (item.title == "Animals") {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_SPECIES,
                category: Constants.tagCategory.TAG_CATEGORY_ZOO_SPECIES,
                ...item.selectedList[0],
              });
            }
          } else if (item.title == "Population") {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_POPULATION,
                category: Constants.tagCategory.TAG_CATEGORY_ZOO_POPULATION,
                ...item.selectedList[0],
              });
            }
          } else if (item.title == "Price") {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_PRICE,
                category: Constants.tagCategory.TAG_CATEGORY_PRICE,
                ...item.selectedList[0],
              });
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: Constants.categoryType.CATEGORY_ZOO,
      startDateFrom,
      startDateTo,
      isAnytime,
      venueStatus,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexZoo - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedZoo,
      pageSize: pageSizeZoo,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
    };
  };

  const getDataZoo = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataZoo) {
        return false;
      }
      setIsLoadingNextPageZoo(true);
    } else {
      setIsLoadingZoo(true);
      if (!isCountOnly) {
        setItemsZoo([]);
        setListZoo([]);
      }
    }
    const params = convertParamsZoo(isNextPage, category);
    VenueDao.find(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_ZOO) {
          _category[index].count = result.totalCount;
          if (setCountZoo) {
            setCountZoo(result.totalCount);
          }
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageZoo(false);
      setIsLoadingZoo(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexZoo((isNextPage ? pageIndexZoo : 1) + 1);
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsZoo(uniqBy(itemsZoo.concat(result.data), "id"));
          setListZoo(uniqBy(itemsZoo.concat(result.data), "id"));
        }
      } else {
        setItemsZoo(uniqBy(result.data, "id"));
        setListZoo(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataZoo(true);
      } else {
        setIsNoMoreDataZoo(false);
      }
    });
  };

  const convertParamsAnimal = (isNextPage, category) => {
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    let venueStatus = null;
    if (filterCriteriaListOriginalAnimal) {
      filterCriteriaListOriginalAnimal.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: Constants.categoryType.CATEGORY_ANIMAL,
      startDateFrom,
      startDateTo,
      isAnytime,
      venueStatus,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexAnimal - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedAnimal,
      pageSize: pageSizeAnimal,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
    };
  };

  const getDataAnimal = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataAnimal) {
        return false;
      }
      setIsLoadingNextPageAnimal(true);
    } else {
      setIsLoadingAnimal(true);
      if (!isCountOnly) {
        setItemsAnimal([]);
        setListAnimal([]);
      }
    }
    const params = convertParamsAnimal(isNextPage, category);
    VenueDao.find(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_ANIMAL) {
          _category[index].count = result.totalCount;
          if (setCountAnimal) {
            setCountAnimal(result.totalCount);
          }
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageAnimal(false);
      setIsLoadingAnimal(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexAnimal((isNextPage ? pageIndexAnimal : 1) + 1);
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsAnimal(uniqBy(itemsAnimal.concat(result.data), "id"));
          setListAnimal(uniqBy(itemsAnimal.concat(result.data), "id"));
        }
      } else {
        setItemsAnimal(uniqBy(result.data, "id"));
        setListAnimal(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataAnimal(true);
      } else {
        setIsNoMoreDataAnimal(false);
      }
    });
  };

  const convertParamsParkful = (isNextPage, category) => {
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    let venueStatus = null;
    let amenities = null;
    if (filterCriteriaListOriginalParkful) {
      filterCriteriaListOriginalParkful.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_AMENITIES) {
            if (item.selectedList.length > 0) {
              amenities = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: Constants.categoryType.CATEGORY_PARKFUL,
      startDateFrom,
      startDateTo,
      isAnytime,
      venueStatus,
      amenities,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexAnimal - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedAnimal,
      pageSize: pageSizeAnimal,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
    };
  };

  const getDataParkful = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataParkful) {
        return false;
      }
      setIsLoadingNextPageParkful(true);
    } else {
      setIsLoadingParkful(true);
      if (!isCountOnly) {
        setItemsParkful([]);
        setListParkful([]);
      }
    }
    const params = convertParamsParkful(isNextPage, category);
    VenueDao.find(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_PARKFUL) {
          _category[index].count = result.totalCount;
          if (setCountParkful) {
            setCountParkful(result.totalCount);
          }
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageParkful(false);
      setIsLoadingParkful(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexParkful((isNextPage ? pageIndexParkful : 1) + 1);
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsParkful(uniqBy(itemsParkful.concat(result.data), "id"));
          setListParkful(uniqBy(itemsParkful.concat(result.data), "id"));
        }
      } else {
        setItemsParkful(uniqBy(result.data, "id"));
        setListParkful(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataParkful(true);
      } else {
        setIsNoMoreDataParkful(false);
      }
    });
  };

  const convertParamsCasino = (isNextPage, category) => {
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    let venueStatus = null;
    if (filterCriteriaListOriginalCasino) {
      filterCriteriaListOriginalCasino.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else if (item.title == "Size") {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_SIZE_SQF,
                category: Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT,
                ...item.selectedList[0],
              });
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: Constants.categoryType.CATEGORY_CASINO,
      startDateFrom,
      startDateTo,
      isAnytime,
      venueStatus,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexAnimal - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedAnimal,
      pageSize: pageSizeAnimal,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
    };
  };

  const getDataCasino = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataCasino) {
        return false;
      }
      setIsLoadingNextPageCasino(true);
    } else {
      setIsLoadingCasino(true);
      if (!isCountOnly) {
        setItemsCasino([]);
        setListCasino([]);
      }
    }
    const params = convertParamsCasino(isNextPage, category);
    VenueDao.find(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_CASINO) {
          _category[index].count = result.totalCount;
          if (setCountCasino) {
            setCountCasino(result.totalCount);
          }
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageCasino(false);
      setIsLoadingCasino(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexCasino((isNextPage ? pageIndexCasino : 1) + 1);
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsCasino(uniqBy(itemsCasino.concat(result.data), "id"));
          setListCasino(uniqBy(itemsCasino.concat(result.data), "id"));
        }
      } else {
        setItemsCasino(uniqBy(result.data, "id"));
        setListCasino(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataCasino(true);
      } else {
        setIsNoMoreDataCasino(false);
      }
    });
  };

  const convertParamsCastle = (isNextPage, category) => {
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    let venueStatus = null;
    let amenities = null;
    if (filterCriteriaListOriginalCastle) {
      filterCriteriaListOriginalCastle.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_AMENITIES) {
            if (item.selectedList.length > 0) {
              amenities = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: Constants.categoryType.CATEGORY_CASTLE,
      startDateFrom,
      startDateTo,
      isAnytime,
      venueStatus,
      amenities,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexAnimal - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedAnimal,
      pageSize: pageSizeAnimal,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
    };
  };

  const getDataCastle = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataCastle) {
        return false;
      }
      setIsLoadingNextPageCastle(true);
    } else {
      setIsLoadingCastle(true);
      if (!isCountOnly) {
        setItemsCastle([]);
        setListCastle([]);
      }
    }
    const params = convertParamsCastle(isNextPage, category);
    VenueDao.find(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_CASTLE) {
          _category[index].count = result.totalCount;
          if (setCountCastle) {
            setCountCastle(result.totalCount);
          }
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageCastle(false);
      setIsLoadingCastle(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexCastle((isNextPage ? pageIndexCastle : 1) + 1);
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsCastle(uniqBy(itemsCastle.concat(result.data), "id"));
          setListCastle(uniqBy(itemsCastle.concat(result.data), "id"));
        }
      } else {
        setItemsCastle(uniqBy(result.data, "id"));
        setListCastle(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataCastle(true);
      } else {
        setIsNoMoreDataCastle(false);
      }
    });
  };

  const convertParamsResort = (isNextPage, category) => {
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    let venueStatus = null;
    let amenities = null;
    if (filterCriteriaListOriginalResort) {
      filterCriteriaListOriginalResort.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_AMENITIES) {
            if (item.selectedList.length > 0) {
              amenities = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: Constants.categoryType.CATEGORY_RESORT,
      startDateFrom,
      startDateTo,
      isAnytime,
      venueStatus,
      amenities,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexAnimal - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedAnimal,
      pageSize: pageSizeAnimal,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
    };
  };

  const getDataResort = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataResort) {
        return false;
      }
      setIsLoadingNextPageResort(true);
    } else {
      setIsLoadingResort(true);
      if (!isCountOnly) {
        setItemsResort([]);
        setListResort([]);
      }
    }
    const params = convertParamsResort(isNextPage, category);
    VenueDao.find(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_RESORT) {
          _category[index].count = result.totalCount;
          if (setCountResort) {
            setCountResort(result.totalCount);
          }
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageResort(false);
      setIsLoadingResort(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexResort((isNextPage ? pageIndexResort : 1) + 1);
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsResort(uniqBy(itemsResort.concat(result.data), "id"));
          setListResort(uniqBy(itemsResort.concat(result.data), "id"));
        }
      } else {
        setItemsResort(uniqBy(result.data, "id"));
        setListResort(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataResort(true);
      } else {
        setIsNoMoreDataResort(false);
      }
    });
  };

  const convertParamsAparthotel = (isNextPage, category) => {
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    let venueStatus = null;
    let amenities = null;
    if (filterCriteriaListOriginalAparthotel) {
      filterCriteriaListOriginalAparthotel.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_AMENITIES) {
            if (item.selectedList.length > 0) {
              amenities = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: Constants.categoryType.CATEGORY_APARTHOTEL,
      startDateFrom,
      startDateTo,
      isAnytime,
      venueStatus,
      amenities,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexAnimal - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedAnimal,
      pageSize: pageSizeAnimal,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
    };
  };

  const getDataAparthotel = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataAparthotel) {
        return false;
      }
      setIsLoadingNextPageAparthotel(true);
    } else {
      setIsLoadingAparthotel(true);
      if (!isCountOnly) {
        setItemsAparthotel([]);
        setListAparthotel([]);
      }
    }
    const params = convertParamsAparthotel(isNextPage, category);
    VenueDao.find(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_APARTHOTEL) {
          _category[index].count = result.totalCount;
          if (setCountAparthotel) {
            setCountAparthotel(result.totalCount);
          }
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageAparthotel(false);
      setIsLoadingAparthotel(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexAparthotel((isNextPage ? pageIndexAparthotel : 1) + 1);
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsAparthotel(uniqBy(itemsAparthotel.concat(result.data), "id"));
          setListAparthotel(uniqBy(itemsAparthotel.concat(result.data), "id"));
        }
      } else {
        setItemsAparthotel(uniqBy(result.data, "id"));
        setListAparthotel(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataAparthotel(true);
      } else {
        setIsNoMoreDataAparthotel(false);
      }
    });
  };

  const convertParamsVenueCocktail = (isNextPage, category) => {
    let tagFilters = [];
    let startDateFrom = null;
    let startDateTo = null;
    let sortByCharts = null;
    let isAnytime = null;
    let isUpcoming = null;
    let venueStatus = null;
    if (filterCriteriaListOriginalVenueCocktail) {
      filterCriteriaListOriginalVenueCocktail.forEach((item) => {
        if (item.selectedList) {
          if (
            item.isDate &&
            (item.selectedList?.start ||
              item.selectedList?.isUpcoming ||
              item.selectedList?.isAnytime)
          ) {
            if (item.selectedList?.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if (item.selectedList?.isUpcoming) {
              startDateFrom = moment().format("YYYY-MM-DD");
              startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if (item.selectedList?.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: Constants.tagIds.TAG_ID_AGE,
                category: Constants.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: Constants.tagUnit.TAG_UNIT_AGE,
              });
            }
          } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if (item.selectedList?.filter((i) => i > 800 && i < 900)) {
                tagFilters.push({
                  category: Constants.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: item.selectedList?.filter((i) => i > 800 && i < 900),
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment(`${item.selectedList[0]}-01-01`).format(
                "YYYY-MM-DD"
              );
              startDateTo = moment(`${item.selectedList[0]}-12-31`).format(
                "YYYY-MM-DD"
              );
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: Constants.categoryType.CATEGORY_VENUE_COCKTAIL,
      startDateFrom,
      startDateTo,
      isAnytime,
      venueStatus,
      keyword: keyword,
      pageIndex:
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
          ? isNextPage
            ? pageIndexVenueCocktail - 1
            : 0
          : parseInt(currentPageIndex) - 1,
      tagFilters,
      filterFollowLogic: filterTabSelectedVenueCocktail,
      pageSize: pageSizeVenueCocktail,
      range:
        locationSelected?.city_id && locationSelected?.distance > 0
          ? locationSelected?.distance
          : null,
      distanceUnit: locationSelected?.city_id
        ? Constants.distanceUnit.DISTANCE_UNIT_KM
        : null,
      countryId: locationSelected?.country_id
        ? [locationSelected?.country_id]
        : null,
      cityId: locationSelected?.city_id,
      stateId: locationSelected?.state_id,
      dateSortType: isUpcoming
        ? Constants.dateFilterType.DATE_FILTER_UPCOMING
        : null,
      sortType: sortByCharts || sortBy,
    };
  };

  const getDataVenueCocktail = (isNextPage, category, isCountOnly) => {
    if (isNextPage) {
      if (isNoMoreDataVenueCocktail) {
        return false;
      }
      setIsLoadingNextPageVenueCocktail(true);
    } else {
      setIsLoadingVenueCocktail(true);
      if (!isCountOnly) {
        setItemsVenueCocktail([]);
        setListVenueCocktail([]);
      }
    }
    const params = convertParamsVenueCocktail(isNextPage, category);
    VenueDao.find(params).then((result) => {
      const _category = category;
      _category.forEach((item, index) => {
        if (item.id === Constants.categoryType.CATEGORY_VENUE_COCKTAIL) {
          _category[index].count = result.totalCount;
          if (setCountVenueCocktail) {
            setCountVenueCocktail(result.totalCount);
          }
        }
      });
      setCategoryList(_category);

      setIsLoadingNextPageVenueCocktail(false);
      setIsLoadingVenueCocktail(false);
      if (isCountOnly) {
        return false;
      }
      if (
        isEnabledInfiniteScroll ||
        passViewMode === Constants.viewType.VIEW_TYPE_MAP
      ) {
        setPageIndexVenueCocktail(
          (isNextPage ? pageIndexVenueCocktail : 1) + 1
        );
      }
      if (isNextPage) {
        if (result.data?.length > 0) {
          setItemsVenueCocktail(
            uniqBy(itemsVenueCocktail.concat(result.data), "id")
          );
          setListVenueCocktail(
            uniqBy(itemsVenueCocktail.concat(result.data), "id")
          );
        }
      } else {
        setItemsVenueCocktail(uniqBy(result.data, "id"));
        setListVenueCocktail(uniqBy(result.data, "id"));
      }
      if (result.data?.length <= 0) {
        setIsNoMoreDataVenueCocktail(true);
      } else {
        setIsNoMoreDataVenueCocktail(false);
      }
    });
  };

  const loadItems = (isNextPage, category, isPartialLoad) => {
    if (isMobileVersion) {
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_FESTIVAL &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Festivals"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "Festyful") {
          getDataFestival(isNextPage, category, false);
          getDataArtist(isNextPage, category, true);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_EVENT &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Events"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "Vybeful") {
          getDataEvent(isNextPage, category, false);
          getDataVenue(isNextPage, category, true);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_ARTIST &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Artists"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "Festyful") {
          getDataFestival(isNextPage, category, true);
          getDataArtist(isNextPage, category, false);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_VENUE &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Venues"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "Vybeful") {
          getDataEvent(isNextPage, category, true);
          getDataVenue(isNextPage, category, false);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_ROOFTOP &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Rooftops"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub") {
          getDataRooftop(isNextPage, category, false);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_SPA &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Spas"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "SpaClub") {
          getDataSpa(isNextPage, category, false);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_VENUE_BEACHFUL &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Venue Beachful"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "Beachful") {
          getDataVenueBeachful(isNextPage, category, false);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_PREFAB_COMPANY &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Prefab Company"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld") {
          getDataPrefabCompany(isNextPage, category, false);
          getDataPrefabHome(isNextPage, category, true);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_PREFAB_HOMES &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Prefab Home"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld") {
          getDataPrefabCompany(isNextPage, category, true);
          getDataPrefabHome(isNextPage, category, false);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_ZOO &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Zoos"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia") {
          getDataZoo(isNextPage, category, false);
          getDataAnimal(isNextPage, category, true);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_ANIMAL &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Animals"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia") {
          getDataZoo(isNextPage, category, true);
          getDataAnimal(isNextPage, category, false);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_PARKFUL &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Parks"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "Parkful") {
          getDataParkful(isNextPage, category, false);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_CASINO &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Casinos"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino") {
          getDataCasino(isNextPage, category, false);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_CASTLE &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Castles"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia") {
          getDataCastle(isNextPage, category, false);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_RESORT &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Resorts"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club") {
          getDataResort(isNextPage, category, false);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_APARTHOTEL &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Aparthotels"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub") {
          getDataAparthotel(isNextPage, category, false);
        }
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_VENUE_COCKTAIL &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Venue Cocktail"
        )
      ) {
        if (process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl") {
          getDataVenueCocktail(isNextPage, category, false);
        }
      }
    } else {
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_FESTIVAL &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Festivals"
        )
      ) {
        getDataFestival(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_EVENT &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Events"
        )
      ) {
        getDataEvent(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_ARTIST &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Artists"
        )
      ) {
        getDataArtist(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_VENUE &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Venues"
        )
      ) {
        getDataVenue(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_ROOFTOP &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Rooftops"
        )
      ) {
        getDataRooftop(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_SPA &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Spas"
        )
      ) {
        getDataSpa(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_VENUE_BEACHFUL &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Venue Beachful"
        )
      ) {
        getDataVenueBeachful(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_PREFAB_COMPANY &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Prefab Company"
        )
      ) {
        getDataPrefabCompany(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_PREFAB_HOMES &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Prefab Home"
        )
      ) {
        getDataPrefabHome(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_ZOO &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Zoos"
        )
      ) {
        getDataZoo(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_ANIMAL &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Animals"
        )
      ) {
        getDataAnimal(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_PARKFUL &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Parks"
        )
      ) {
        getDataParkful(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_CASINO &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Casinos"
        )
      ) {
        getDataCasino(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_CASTLE &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Castles"
        )
      ) {
        getDataCastle(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_RESORT &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Resorts"
        )
      ) {
        getDataResort(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_APARTHOTEL &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Aparthotels"
        )
      ) {
        getDataAparthotel(isNextPage, category);
      }
      if (
        isPartialLoad &&
        dataCategory == Constants.categoryType.CATEGORY_VENUE_COCKTAIL &&
        process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(",").find(
          (i) => i === "Venue Cocktail"
        )
      ) {
        getDataVenueCocktail(isNextPage, category);
      }
    }
  };

  // Search keyword change
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialized || keyword) {
        if (keyword !== "") {
          onLoad();
        }
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [keyword, isInitialized]);

  // Non mobile version load
  useEffect(() => {
    if (!isInitialized && sortBy && !isMobileVersion) {
      onLoad();
    }
  }, [
    sortBy,
    currentPageIndex,
    isInitialized,
    isMobileVersion,
    dataCategory,
    JSON.stringify(locationSelected),
  ]);

  // Mobile version load
  useEffect(() => {
    if (!isInitialized && sortBy && isMobileVersion) {
      onLoad();
    }
  }, [
    sortBy,
    currentPageIndex,
    isInitialized,
    isMobileVersion,
    dataCategory,
    JSON.stringify(locationSelected),
  ]);

  // Filter Criteria Change
  useEffect(() => {
    if (filterCriteriaListOriginalFestival) {
      onLoad();
    }
  }, [filterCriteriaListOriginalFestival]);

  useEffect(() => {
    if (filterCriteriaListOriginalEvent) {
      onLoad();
    }
  }, [filterCriteriaListOriginalEvent]);

  useEffect(() => {
    if (filterCriteriaListOriginalArtist) {
      onLoad();
    }
  }, [filterCriteriaListOriginalArtist]);

  useEffect(() => {
    if (filterCriteriaListOriginalVenue) {
      onLoad();
    }
  }, [filterCriteriaListOriginalVenue]);

  useEffect(() => {
    if (filterCriteriaListOriginalRooftop) {
      onLoad();
    }
  }, [filterCriteriaListOriginalRooftop]);

  useEffect(() => {
    if (filterCriteriaListOriginalSpa) {
      onLoad();
    }
  }, [filterCriteriaListOriginalSpa]);

  useEffect(() => {
    if (filterCriteriaListOriginalVenueBeachful) {
      onLoad();
    }
  }, [filterCriteriaListOriginalVenueBeachful]);

  useEffect(() => {
    if (filterCriteriaListOriginalPrefabCompany) {
      onLoad();
    }
  }, [filterCriteriaListOriginalPrefabCompany]);

  useEffect(() => {
    if (filterCriteriaListOriginalPrefabHome) {
      onLoad();
    }
  }, [filterCriteriaListOriginalPrefabHome]);

  useEffect(() => {
    if (filterCriteriaListOriginalZoo) {
      onLoad();
    }
  }, [filterCriteriaListOriginalZoo]);

  useEffect(() => {
    if (filterCriteriaListOriginalAnimal) {
      onLoad();
    }
  }, [filterCriteriaListOriginalAnimal]);

  useEffect(() => {
    if (filterCriteriaListOriginalParkful) {
      onLoad();
    }
  }, [filterCriteriaListOriginalParkful]);

  useEffect(() => {
    if (filterCriteriaListOriginalCasino) {
      onLoad();
    }
  }, [filterCriteriaListOriginalCasino]);

  useEffect(() => {
    if (filterCriteriaListOriginalCastle) {
      onLoad();
    }
  }, [filterCriteriaListOriginalCastle]);

  useEffect(() => {
    if (filterCriteriaListOriginalResort) {
      onLoad();
    }
  }, [filterCriteriaListOriginalResort]);

  useEffect(() => {
    if (filterCriteriaListOriginalAparthotel) {
      onLoad();
    }
  }, [filterCriteriaListOriginalAparthotel]);

  useEffect(() => {
    if (filterCriteriaListOriginalVenueCocktail) {
      onLoad();
    }
  }, [filterCriteriaListOriginalVenueCocktail]);

  const showPageList = 1000;
  const totalPage =
    dataCategory === Constants.categoryType.CATEGORY_FESTIVAL
      ? Math.ceil(
          (countFestival > 100 && isChartsMode ? 100 : countFestival) /
            pageSizeFestival
        )
      : dataCategory === Constants.categoryType.CATEGORY_EVENT
      ? Math.ceil(
          (countEvent > 100 && isChartsMode ? 100 : countEvent) / pageSizeEvent
        )
      : dataCategory === Constants.categoryType.CATEGORY_ARTIST
      ? Math.ceil(
          (countArtist > 100 && isChartsMode ? 100 : countArtist) /
            pageSizeArtist
        )
      : dataCategory === Constants.categoryType.CATEGORY_ROOFTOP
      ? Math.ceil(
          (countRooftop > 100 && isChartsMode ? 100 : countRooftop) /
            pageSizeRooftop
        )
      : dataCategory === Constants.categoryType.CATEGORY_SPA
      ? Math.ceil(
          (countSpa > 100 && isChartsMode ? 100 : countSpa) / pageSizeSpa
        )
      : dataCategory === Constants.categoryType.CATEGORY_VENUE_BEACHFUL
      ? Math.ceil(
          (countVenueBeachful > 100 && isChartsMode
            ? 100
            : countVenueBeachful) / pageSizeVenueBeachful
        )
      : dataCategory === Constants.categoryType.CATEGORY_PREFAB_COMPANY
      ? Math.ceil(
          (countPrefabCompany > 100 && isChartsMode
            ? 100
            : countPrefabCompany) / pageSizePrefabCompany
        )
      : dataCategory === Constants.categoryType.CATEGORY_PREFAB_HOMES
      ? Math.ceil(
          (countPrefabHome > 100 && isChartsMode ? 100 : countPrefabHome) /
            pageSizePrefabHome
        )
      : dataCategory === Constants.categoryType.CATEGORY_ZOO
      ? Math.ceil(
          (countZoo > 100 && isChartsMode ? 100 : countZoo) / pageSizeZoo
        )
      : dataCategory === Constants.categoryType.CATEGORY_ANIMAL
      ? Math.ceil(
          (countAnimal > 100 && isChartsMode ? 100 : countAnimal) /
            pageSizeAnimal
        )
      : dataCategory === Constants.categoryType.CATEGORY_PARKFUL
      ? Math.ceil(
          (countParkful > 100 && isChartsMode ? 100 : countParkful) /
            pageSizeParkful
        )
      : dataCategory === Constants.categoryType.CATEGORY_CASINO
      ? Math.ceil(
          (countCasino > 100 && isChartsMode ? 100 : countCasino) /
            pageSizeCasino
        )
      : dataCategory === Constants.categoryType.CATEGORY_CASTLE
      ? Math.ceil(
          (countCastle > 100 && isChartsMode ? 100 : countCastle) /
            pageSizeCastle
        )
      : dataCategory === Constants.categoryType.CATEGORY_RESORT
      ? Math.ceil(
          (countResort > 100 && isChartsMode ? 100 : countResort) /
            pageSizeResort
        )
      : dataCategory === Constants.categoryType.CATEGORY_APARTHOTEL
      ? Math.ceil(
          (countAparthotel > 100 && isChartsMode ? 100 : countAparthotel) /
            pageSizeAparthotel
        )
      : dataCategory === Constants.categoryType.CATEGORY_VENUE_COCKTAIL
      ? Math.ceil(
          (countVenueCocktail > 100 && isChartsMode
            ? 100
            : countVenueCocktail) / pageSizeVenueCocktail
        )
      : Math.ceil(
          (countVenue > 100 && isChartsMode ? 100 : countVenue) / pageSizeVenue
        );
  const startPage =
    parseInt(currentPageIndex) - showPageList <= 0
      ? 1
      : parseInt(currentPageIndex) - showPageList;
  const endPage =
    parseInt(currentPageIndex) + showPageList > totalPage
      ? totalPage
      : parseInt(currentPageIndex) + showPageList;
  const nextPage =
    parseInt(currentPageIndex) + 1 > totalPage
      ? totalPage
      : parseInt(currentPageIndex) + 1;
  const prevPage =
    parseInt(currentPageIndex) - 1 < 1 ? 1 : parseInt(currentPageIndex) - 1;

  useEffect(() => {
    pageScrollRef.current?.scrollIntoView();
  }, [isOpenPage]);

  return (
    <View style={styles.background}>
      <View style={styles.background}>
        <StatusBar />
        {dataCategory === Constants.categoryType.CATEGORY_FESTIVAL && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsFestival}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageFestival}
                isLoading={isLoadingFestival}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingFestival
                    ? getDataFestival(false, categoryList)
                    : null
                }
                onLoadMore={() =>
                  !isLoadingFestival
                    ? getDataFestival(true, categoryList)
                    : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeFestival
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsFestival}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageFestival}
                isLoading={isLoadingFestival}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingFestival
                    ? getDataFestival(false, categoryList)
                    : null
                }
                onLoadMore={() =>
                  !isLoadingFestival
                    ? getDataFestival(true, categoryList)
                    : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeFestival
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <PopularListSectionContainer
                  style={{
                    marginBottom: 20,
                    marginTop: 35,
                  }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsArtist={convertParamsArtist()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsArtist={convertParamsArtist()}
                  paramsFestival={convertParamsFestival()}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsFestival}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPageFestival}
                  isLoading={isLoadingFestival}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingFestival
                      ? getDataFestival(false, categoryList)
                      : null
                  }
                  onLoadMore={() =>
                    !isLoadingFestival
                      ? getDataFestival(true, categoryList)
                      : null
                  }
                  gapHeight={150}
                  currentPageIndex={
                    parseInt(currentPageIndex) * pageSizeFestival
                  }
                />
              </>
            )}
            {isLoadingFestival &&
              pageIndexFestival > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}
        {dataCategory === Constants.categoryType.CATEGORY_EVENT && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsEvent}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageEvent}
                isLoading={isLoadingEvent}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingEvent ? getDataEvent(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingEvent ? getDataEvent(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeEvent
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsEvent}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageEvent}
                isLoading={isLoadingEvent}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingEvent ? getDataEvent(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingEvent ? getDataEvent(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeEvent
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <PopularListSectionContainer
                  style={{
                    marginBottom: 20,
                    marginTop: 35,
                  }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginaPrefabCompany={
                    filterCriteriaListOriginaPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsArtist={convertParamsArtist()}
                  paramsFestival={convertParamsFestival()}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsEvent}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPageEvent}
                  isLoading={isLoadingEvent}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingEvent ? getDataEvent(false, categoryList) : null
                  }
                  onLoadMore={() =>
                    !isLoadingEvent ? getDataEvent(true, categoryList) : null
                  }
                  gapHeight={150}
                  currentPageIndex={parseInt(currentPageIndex) * pageSizeEvent}
                />
              </>
            )}
            {isLoadingEvent &&
              pageIndexEvent > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}
        {dataCategory === Constants.categoryType.CATEGORY_ARTIST && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsArtist}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageArtist}
                isLoading={isLoadingArtist}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingArtist ? getDataArtist(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingArtist ? getDataArtist(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeArtist
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsArtist}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageArtist}
                isLoading={isLoadingArtist}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingArtist ? getDataArtist(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingArtist ? getDataArtist(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeArtist
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <PopularListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsArtist={convertParamsArtist()}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsCAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsArtist={convertParamsArtist()}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {isLoadingArtist &&
              pageIndexArtist > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}
        {dataCategory === Constants.categoryType.CATEGORY_VENUE && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsVenue}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageVenue}
                isLoading={isLoadingVenue}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingVenue ? getDataVenue(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingVenue ? getDataVenue(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeVenue
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsVenue}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageVenue}
                isLoading={isLoadingVenue}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingVenue ? getDataVenue(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingVenue ? getDataVenue(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeVenue
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <RecommendedListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsVenue}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPageVenue}
                  isLoading={isLoadingVenue}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingVenue ? getDataVenue(false, categoryList) : null
                  }
                  onLoadMore={() =>
                    !isLoadingVenue ? getDataVenue(true, categoryList) : null
                  }
                  gapHeight={150}
                  currentPageIndex={parseInt(currentPageIndex) * pageSizeVenue}
                />
              </>
            )}
            {isLoadingVenue &&
              pageIndexVenue > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}

        {dataCategory === Constants.categoryType.CATEGORY_ROOFTOP && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsRooftop}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageRooftop}
                isLoading={isLoadingRooftop}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingRooftop ? getDataRooftop(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingRooftop ? getDataRooftop(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeRooftop
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsRooftop}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageRooftop}
                isLoading={isLoadingRooftop}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingRooftop ? getDataRooftop(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingRooftop ? getDataRooftop(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeRooftop
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <RecommendedListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsRooftop}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPageRooftop}
                  isLoading={isLoadingRooftop}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingRooftop
                      ? getDataRooftop(false, categoryList)
                      : null
                  }
                  onLoadMore={() =>
                    !isLoadingRooftop
                      ? getDataRooftop(true, categoryList)
                      : null
                  }
                  gapHeight={150}
                  currentPageIndex={
                    parseInt(currentPageIndex) * pageSizeRooftop
                  }
                />
              </>
            )}
            {isLoadingRooftop &&
              pageIndexRooftop > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}

        {dataCategory === Constants.categoryType.CATEGORY_SPA && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsSpa}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageSpa}
                isLoading={isLoadingSpa}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingSpa ? getDataSpa(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingSpa ? getDataSpa(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeSpa
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsSpa}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageSpa}
                isLoading={isLoadingSpa}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingSpa ? getDataSpa(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingSpa ? getDataSpa(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeSpa
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <RecommendedListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsSpa}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPageSpa}
                  isLoading={isLoadingSpa}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingSpa ? getDataSpa(false, categoryList) : null
                  }
                  onLoadMore={() =>
                    !isLoadingSpa ? getDataSpa(true, categoryList) : null
                  }
                  gapHeight={150}
                  currentPageIndex={parseInt(currentPageIndex) * pageSizeSpa}
                />
              </>
            )}
            {isLoadingSpa &&
              pageIndexSpa > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}

        {dataCategory === Constants.categoryType.CATEGORY_VENUE_BEACHFUL && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsVenueBeachful}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageVenueBeachful}
                isLoading={isLoadingVenueBeachful}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingVenueBeachful
                    ? getDataVenueBeachful(false, categoryList)
                    : null
                }
                onLoadMore={() =>
                  !isLoadingVenueBeachful
                    ? getDataVenueBeachful(true, categoryList)
                    : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeVenueBeachful
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsVenueBeachful}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageVenueBeachful}
                isLoading={isLoadingVenueBeachful}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingVenueBeachful
                    ? getDataVenueBeachful(false, categoryList)
                    : null
                }
                onLoadMore={() =>
                  !isLoadingVenueBeachful
                    ? getDataVenueBeachful(true, categoryList)
                    : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeVenueBeachful
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <RecommendedListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsVenueBeachful}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPageVenueBeachful}
                  isLoading={isLoadingVenueBeachful}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingVenueBeachful
                      ? getDataVenueBeachful(false, categoryList)
                      : null
                  }
                  onLoadMore={() =>
                    !isLoadingVenueBeachful
                      ? getDataVenueBeachful(true, categoryList)
                      : null
                  }
                  gapHeight={150}
                  currentPageIndex={
                    parseInt(currentPageIndex) * pageSizeVenueBeachful
                  }
                />
              </>
            )}
            {isLoadingVenueBeachful &&
              pageIndexVenueBeachful > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}

        {dataCategory === Constants.categoryType.CATEGORY_PREFAB_COMPANY && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsPrefabCompany}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPagePrefabCompany}
                isLoading={isLoadingPrefabCompany}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingPrefabCompany
                    ? getDataPrefabCompany(false, categoryList)
                    : null
                }
                onLoadMore={() =>
                  !isLoadingPrefabCompany
                    ? getDataPrefabCompany(true, categoryList)
                    : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizePrefabCompany
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsPrefabCompany}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPagePrefabCompany}
                isLoading={isLoadingPrefabCompany}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingPrefabCompany
                    ? getDataPrefabCompany(false, categoryList)
                    : null
                }
                onLoadMore={() =>
                  !isLoadingPrefabCompany
                    ? getDataPrefabCompany(true, categoryList)
                    : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizePrefabCompany
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <RecommendedListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsPrefabCompany}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPagePrefabCompany}
                  isLoading={isLoadingPrefabCompany}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingPrefabCompany
                      ? getDataPrefabCompany(false, categoryList)
                      : null
                  }
                  onLoadMore={() =>
                    !isLoadingPrefabCompany
                      ? getDataPrefabCompany(true, categoryList)
                      : null
                  }
                  gapHeight={150}
                  currentPageIndex={
                    parseInt(currentPageIndex) * pageSizePrefabCompany
                  }
                />
              </>
            )}
            {isLoadingPrefabCompany &&
              pageIndexPrefabCompany > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}

        {dataCategory === Constants.categoryType.CATEGORY_PREFAB_HOMES && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsPrefabHome}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPagePrefabHome}
                isLoading={isLoadingPrefabHome}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingPrefabHome
                    ? getDataPrefabHome(false, categoryList)
                    : null
                }
                onLoadMore={() =>
                  !isLoadingPrefabHome
                    ? getDataPrefabHome(true, categoryList)
                    : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizePrefabHome
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsPrefabHome}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPagePrefabHome}
                isLoading={isLoadingPrefabHome}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingPrefabHome
                    ? getDataPrefabHome(false, categoryList)
                    : null
                }
                onLoadMore={() =>
                  !isLoadingPrefabHome
                    ? getDataPrefabHome(true, categoryList)
                    : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizePrefabHome
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <RecommendedListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsPrefabHome}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPagePrefabHome}
                  isLoading={isLoadingPrefabHome}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingPrefabHome
                      ? getDataPrefabHome(false, categoryList)
                      : null
                  }
                  onLoadMore={() =>
                    !isLoadingPrefabHome
                      ? getDataPrefabHome(true, categoryList)
                      : null
                  }
                  gapHeight={150}
                  currentPageIndex={
                    parseInt(currentPageIndex) * pageSizePrefabHome
                  }
                />
              </>
            )}
            {isLoadingPrefabHome &&
              pageIndexPrefabHome > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}

        {dataCategory === Constants.categoryType.CATEGORY_ZOO && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsZoo}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageZoo}
                isLoading={isLoadingZoo}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingZoo ? getDataZoo(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingZoo ? getDataZoo(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeZoo
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsZoo}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageZoo}
                isLoading={isLoadingZoo}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingZoo ? getDataZoo(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingZoo ? getDataZoo(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeZoo
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <RecommendedListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsZoo}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPageZoo}
                  isLoading={isLoadingZoo}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingZoo ? getDataZoo(false, categoryList) : null
                  }
                  onLoadMore={() =>
                    !isLoadingZoo ? getDataZoo(true, categoryList) : null
                  }
                  gapHeight={150}
                  currentPageIndex={parseInt(currentPageIndex) * pageSizeZoo}
                />
              </>
            )}
            {isLoadingZoo &&
              pageIndexZoo > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}

        {dataCategory === Constants.categoryType.CATEGORY_ANIMAL && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsAnimal}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageAnimal}
                isLoading={isLoadingAnimal}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingAnimal ? getDataAnimal(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingAnimal ? getDataAnimal(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeAnimal
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsAnimal}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageAnimal}
                isLoading={isLoadingAnimal}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingAnimal ? getDataAnimal(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingAnimal ? getDataAnimal(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeAnimal
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <RecommendedListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsAnimal}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPageAnimal}
                  isLoading={isLoadingAnimal}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingAnimal ? getDataAnimal(false, categoryList) : null
                  }
                  onLoadMore={() =>
                    !isLoadingAnimal ? getDataAnimal(true, categoryList) : null
                  }
                  gapHeight={150}
                  currentPageIndex={parseInt(currentPageIndex) * pageSizeAnimal}
                />
              </>
            )}
            {isLoadingAnimal &&
              pageIndexAnimal > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}

        {dataCategory === Constants.categoryType.CATEGORY_PARKFUL && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsParkful}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageParkful}
                isLoading={isLoadingParkful}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingParkful ? getDataParkful(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingParkful ? getDataParkful(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeParkful
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsParkful}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageParkful}
                isLoading={isLoadingParkful}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingParkful ? getDataParkful(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingParkful ? getDataParkful(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeParkful
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <RecommendedListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsParkful}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPageParkful}
                  isLoading={isLoadingParkful}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingParkful
                      ? getDataParkful(false, categoryList)
                      : null
                  }
                  onLoadMore={() =>
                    !isLoadingParkful
                      ? getDataParkful(true, categoryList)
                      : null
                  }
                  gapHeight={150}
                  currentPageIndex={
                    parseInt(currentPageIndex) * pageSizeParkful
                  }
                />
              </>
            )}
            {isLoadingParkful &&
              pageIndexParkful > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}

        {dataCategory === Constants.categoryType.CATEGORY_CASINO && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsCasino}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageCasino}
                isLoading={isLoadingCasino}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingCasino ? getDataCasino(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingCasino ? getDataCasino(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeCasino
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsCasino}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageCasino}
                isLoading={isLoadingCasino}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingCasino ? getDataCasino(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingCasino ? getDataCasino(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeCasino
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <RecommendedListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsCasino}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPageCasino}
                  isLoading={isLoadingCasino}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingCasino ? getDataCasino(false, categoryList) : null
                  }
                  onLoadMore={() =>
                    !isLoadingCasino ? getDataCasino(true, categoryList) : null
                  }
                  gapHeight={150}
                  currentPageIndex={parseInt(currentPageIndex) * pageSizeCasino}
                />
              </>
            )}
            {isLoadingCasino &&
              pageIndexCasino > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}

        {dataCategory === Constants.categoryType.CATEGORY_CASTLE && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsCastle}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageCastle}
                isLoading={isLoadingCastle}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingCastle ? getDataCastle(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingCastle ? getDataCastle(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeCastle
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsCastle}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageCastle}
                isLoading={isLoadingCastle}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingCastle ? getDataCastle(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingCastle ? getDataCastle(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeCastle
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <RecommendedListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsCastle}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPageCastle}
                  isLoading={isLoadingCastle}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingCastle ? getDataCastle(false, categoryList) : null
                  }
                  onLoadMore={() =>
                    !isLoadingCastle ? getDataCastle(true, categoryList) : null
                  }
                  gapHeight={150}
                  currentPageIndex={parseInt(currentPageIndex) * pageSizeCastle}
                />
              </>
            )}
            {isLoadingCastle &&
              pageIndexCastle > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}

        {dataCategory === Constants.categoryType.CATEGORY_RESORT && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsResort}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageResort}
                isLoading={isLoadingResort}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingResort ? getDataResort(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingResort ? getDataResort(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeResort
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsResort}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageResort}
                isLoading={isLoadingResort}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingResort ? getDataResort(false, categoryList) : null
                }
                onLoadMore={() =>
                  !isLoadingResort ? getDataResort(true, categoryList) : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeResort
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <RecommendedListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsResort}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPageResort}
                  isLoading={isLoadingResort}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingResort ? getDataResort(false, categoryList) : null
                  }
                  onLoadMore={() =>
                    !isLoadingResort ? getDataResort(true, categoryList) : null
                  }
                  gapHeight={150}
                  currentPageIndex={parseInt(currentPageIndex) * pageSizeResort}
                />
              </>
            )}
            {isLoadingResort &&
              pageIndexResort > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}

        {dataCategory === Constants.categoryType.CATEGORY_APARTHOTEL && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsAparthotel}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageAparthotel}
                isLoading={isLoadingAparthotel}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingAparthotel
                    ? getDataAparthotel(false, categoryList)
                    : null
                }
                onLoadMore={() =>
                  !isLoadingAparthotel
                    ? getDataAparthotel(true, categoryList)
                    : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeAparthotel
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsAparthotel}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageAparthotel}
                isLoading={isLoadingAparthotel}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingAparthotel
                    ? getDataAparthotel(false, categoryList)
                    : null
                }
                onLoadMore={() =>
                  !isLoadingAparthotel
                    ? getDataAparthotel(true, categoryList)
                    : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeAparthotel
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <RecommendedListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsAparthotel}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPageAparthotel}
                  isLoading={isLoadingAparthotel}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingAparthotel
                      ? getDataAparthotel(false, categoryList)
                      : null
                  }
                  onLoadMore={() =>
                    !isLoadingAparthotel
                      ? getDataAparthotel(true, categoryList)
                      : null
                  }
                  gapHeight={150}
                  currentPageIndex={
                    parseInt(currentPageIndex) * pageSizeAparthotel
                  }
                />
              </>
            )}
            {isLoadingAparthotel &&
              pageIndexAparthotel > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}

        {dataCategory === Constants.categoryType.CATEGORY_VENUE_COCKTAIL && (
          <>
            {passViewMode === Constants.viewType.VIEW_TYPE_GRID && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={true}
                items={itemsVenueCocktail}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageVenueCocktail}
                isLoading={isLoadingVenueCocktail}
                isExploreSearch
                onRefresh={() =>
                  !isLoadingVenueCocktail
                    ? getDataVenueCocktail(false, categoryList)
                    : null
                }
                onLoadMore={() =>
                  !isLoadingVenueCocktail
                    ? getDataVenueCocktail(true, categoryList)
                    : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeVenueCocktail
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_LIST && (
              <CardList
                isChartsMode={isChartsMode}
                horizontal={false}
                gridView={false}
                items={itemsVenueCocktail}
                category={dataCategory}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={isLoadingNextPageVenueCocktail}
                isLoading={isLoadingVenueCocktail}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                onRefresh={() =>
                  !isLoadingVenueCocktail
                    ? getDataVenueCocktail(false, categoryList)
                    : null
                }
                onLoadMore={() =>
                  !isLoadingVenueCocktail
                    ? getDataVenueCocktail(true, categoryList)
                    : null
                }
                disabledInfiniteScroll={!isEnabledInfiniteScroll}
                gapHeight={0}
                currentPageIndex={
                  (parseInt(currentPageIndex) - 1) * pageSizeVenueCocktail
                }
              />
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_OVERVIEW && (
              <div className={`overflow-hidden mr-0 ${contentWidth}`}>
                <RecommendedListSectionContainer
                  style={{ marginBottom: 20, marginTop: 35 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                <TrendingListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                  paramsFestival={convertParamsFestival()}
                  paramsEvent={convertParamsEvent()}
                  paramsArtist={convertParamsArtist()}
                  paramsVenue={convertParamsVenue()}
                  paramsRooftop={convertParamsRooftop()}
                  paramsSpa={convertParamsSpa()}
                  paramsVenueBeachful={convertParamsVenueBeachful()}
                  paramsPrefabCompany={convertParamsPrefabCompany()}
                  paramsPrefabHome={convertParamsPrefabHome()}
                  paramsZoo={convertParamsZoo()}
                  paramsAnimal={convertParamsAnimal()}
                  paramsParkful={convertParamsParkful()}
                  paramsCasino={convertParamsCasino()}
                  paramsCastle={convertParamsCastle()}
                  paramsResort={convertParamsResort()}
                  paramsAparthotel={convertParamsAparthotel()}
                  paramsVenueCocktail={convertParamsVenueCocktail()}
                  filterCriteriaListOriginalFestival={
                    filterCriteriaListOriginalFestival
                  }
                  filterCriteriaListOriginalEvent={
                    filterCriteriaListOriginalEvent
                  }
                  filterCriteriaListOriginalArtist={
                    filterCriteriaListOriginalArtist
                  }
                  filterCriteriaListOriginalVenue={
                    filterCriteriaListOriginalVenue
                  }
                  filterCriteriaListOriginalRooftop={
                    filterCriteriaListOriginalRooftop
                  }
                  filterCriteriaListOriginalSpa={filterCriteriaListOriginalSpa}
                  filterCriteriaListOriginalVenueBeachful={
                    filterCriteriaListOriginalVenueBeachful
                  }
                  filterCriteriaListOriginalPrefabCompany={
                    filterCriteriaListOriginalPrefabCompany
                  }
                  filterCriteriaListOriginalPrefabHome={
                    filterCriteriaListOriginalPrefabHome
                  }
                  filterCriteriaListOriginalZoo={filterCriteriaListOriginalZoo}
                  filterCriteriaListOriginalAnimal={
                    filterCriteriaListOriginalAnimal
                  }
                  filterCriteriaListOriginalParkful={
                    filterCriteriaListOriginalParkful
                  }
                  filterCriteriaListOriginalCasino={
                    filterCriteriaListOriginalCasino
                  }
                  filterCriteriaListOriginalCastle={
                    filterCriteriaListOriginalCastle
                  }
                  filterCriteriaListOriginalResort={
                    filterCriteriaListOriginalResort
                  }
                  filterCriteriaListOriginalAparthotel={
                    filterCriteriaListOriginalAparthotel
                  }
                  filterCriteriaListOriginalVenueCocktail={
                    filterCriteriaListOriginalVenueCocktail
                  }
                  isChartsMode={isChartsMode}
                />
                {/* <RecommendedListSectionContainer
                  style={{ marginBottom: 20 }}
                  category={dataCategory}
                  locationSelected={locationSelected}
                /> */}
              </div>
            )}
            {passViewMode === Constants.viewType.VIEW_TYPE_MAP && (
              <>
                <CardList
                  isChartsMode={isChartsMode}
                  mapFocused={props.mapFocused}
                  setMapFocused={props.setMapFocused}
                  horizontal={false}
                  gridView={true}
                  mapView={true}
                  items={itemsVenueCocktail}
                  category={dataCategory}
                  style={{ marginTop: 16 }}
                  // onItemAction={({ type, item }) =>
                  //   onItemAction({ type, item })
                  // }
                  isLoadingNextPage={isLoadingNextPageVenueCocktail}
                  isLoading={isLoadingVenueCocktail}
                  isExploreSearch
                  onRefresh={() =>
                    !isLoadingVenueCocktail
                      ? getDataVenueCocktail(false, categoryList)
                      : null
                  }
                  onLoadMore={() =>
                    !isLoadingVenueCocktail
                      ? getDataVenueCocktail(true, categoryList)
                      : null
                  }
                  gapHeight={150}
                  currentPageIndex={
                    parseInt(currentPageIndex) * pageSizeVenueCocktail
                  }
                />
              </>
            )}
            {isLoadingVenueCocktail &&
              pageIndexVenueCocktail > 0 &&
              passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
                <View style={{ paddingTop: 20 }}>
                  {/* <ActivityIndicator /> */}
                </View>
              )}
          </>
        )}

        {passViewMode !== Constants.viewType.VIEW_TYPE_MAP &&
          passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW && (
            <div className="flex flex-row items-center justify-between self-center w-full mt-20px sm:max-w-500px max-w-300px">
              <Link
                prefetch={false}
                href={{
                  pathname: router.pathname,
                  query: {
                    ...router.query,
                    page: prevPage,
                  },
                }}>
                <a className="cursor-pointer">
                  <img
                    src={`/icons/${
                      process.env.NEXT_PUBLIC_APP_NAME === "Zoopedia" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "PrefabWorld" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "Parkful" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "WorldCasino" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "Castlepedia" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "LuxResort Club" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "AparthotelClub" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "RooftopClub" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "Cocktayl" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "SpaClub" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "Beachful"
                        ? process.env.NEXT_PUBLIC_APP_NAME?.replace(
                            " ",
                            ""
                          )?.toLowerCase() + "/"
                        : ""
                    }ic_arrow_left.png`}
                    width={isMobileVersion ? 30 : 50}
                    height={isMobileVersion ? 30 : 50}
                    alt="arrow"
                  />
                </a>
              </Link>
              {passViewMode !== Constants.viewType.VIEW_TYPE_MAP &&
                passViewMode !== Constants.viewType.VIEW_TYPE_OVERVIEW &&
                ((dataCategory === Constants.categoryType.CATEGORY_FESTIVAL &&
                  itemsFestival.length > 0) ||
                  (dataCategory === Constants.categoryType.CATEGORY_ARTIST &&
                    itemsArtist.length > 0) ||
                  (dataCategory === Constants.categoryType.CATEGORY_VENUE &&
                    itemsVenue.length > 0) ||
                  (dataCategory === Constants.categoryType.CATEGORY_ROOFTOP &&
                    itemsRooftop.length > 0) ||
                  (dataCategory === Constants.categoryType.CATEGORY_SPA &&
                    itemsSpa.length > 0) ||
                  (dataCategory ===
                    Constants.categoryType.CATEGORY_VENUE_BEACHFUL &&
                    itemsVenueBeachful.length > 0) ||
                  (dataCategory ===
                    Constants.categoryType.CATEGORY_PREFAB_COMPANY &&
                    itemsPrefabCompany.length > 0) ||
                  (dataCategory ===
                    Constants.categoryType.CATEGORY_PREFAB_HOMES &&
                    itemsPrefabHome.length > 0) ||
                  (dataCategory === Constants.categoryType.CATEGORY_ZOO &&
                    itemsZoo.length > 0) ||
                  (dataCategory === Constants.categoryType.CATEGORY_ANIMAL &&
                    itemsAnimal.length > 0) ||
                  (dataCategory === Constants.categoryType.CATEGORY_PARKFUL &&
                    itemsParkful.length > 0) ||
                  (dataCategory === Constants.categoryType.CATEGORY_CASINO &&
                    itemsCasino.length > 0) ||
                  (dataCategory === Constants.categoryType.CATEGORY_CASTLE &&
                    itemsCastle.length > 0) ||
                  (dataCategory === Constants.categoryType.CATEGORY_RESORT &&
                    itemsResort.length > 0) ||
                  (dataCategory ===
                    Constants.categoryType.CATEGORY_APARTHOTEL &&
                    itemsAparthotel.length > 0) ||
                  (dataCategory ===
                    Constants.categoryType.CATEGORY_VENUE_COCKTAIL &&
                    itemsVenueCocktail.length > 0)) &&
                !isLoadingArtist &&
                !isLoadingFestival &&
                !isEnabledInfiniteScroll && (
                  <div className="relative">
                    <div
                      {...buttonPropsPage}
                      className={`${getClass(
                        "custom-gradient"
                      )} cursor-pointer rounded-full p-1px sm:h-50px h-30px sm:w-180px w-140px`}>
                      <div
                        className={`flex flex-row justify-center items-center sm:text-base text-xs font-bold ${getClass(
                          "text-white",
                          true
                        )} ${getClass(
                          "background",
                          true
                        )} w-full h-full rounded-full`}>
                        <div>{parseInt(currentPageIndex)}</div>
                        <div className="px-4">
                          <img
                            src="/icons/ic_arrow_down.png"
                            width="20"
                            height="24"
                            alt="arrow"
                          />
                        </div>
                        <div>{totalPage}</div>
                      </div>
                    </div>
                    <div
                      className={`${
                        isOpenPage ? "visible" : ""
                      } absolute sm:bottom-[50px] bottom-[30px] flex flex-col items-center justify-center left-0 right-0 z-[999] sm:w-180px w-140px overflow-hidden`}
                      role="menu">
                      <div
                        className={`${getClass(
                          "bg-black8",
                          true
                        )} border ${getClass(
                          "border-black",
                          true
                        )} sm:w-140px w-115px overflow-hidden rounded-t-2xl py-2`}>
                        <div
                          className={`${
                            endPage > 10 ? "h-376px" : ""
                          } w-full overflow-y-auto py-2`}>
                          {totalPage > 2000 && (
                            <Link
                              prefetch={false}
                              {...itemPropsPage[2000]}
                              href={{
                                pathname: router.pathname,
                                query: {
                                  ...router.query,
                                  page: totalPage,
                                },
                              }}>
                              <a
                                className={`sm:text-base text-xs font-bold text-center ${getClass(
                                  "text-white",
                                  true
                                )} h-40px flex flex-1 justify-center items-center cursor-pointer transition-all ${getClass(
                                  "hover:bg-black8"
                                )}`}>
                                {totalPage}
                              </a>
                            </Link>
                          )}
                          {totalPage > 2000 && (
                            <div
                              className={`sm:text-base text-xs font-bold text-center ${getClass(
                                "text-white",
                                true
                              )} h-40px flex flex-1 justify-center items-center cursor-pointer transition-all ${getClass(
                                "hover:bg-black8"
                              )}`}>
                              ...
                            </div>
                          )}
                          {reverse(range(startPage, endPage + 1, 1)).map(
                            (item, index) =>
                              item === parseInt(currentPageIndex) ? null : (
                                <Link
                                  prefetch={false}
                                  {...itemPropsPage[index]}
                                  href={{
                                    pathname: router.pathname,
                                    query: {
                                      ...router.query,
                                      page: item,
                                    },
                                  }}>
                                  <a
                                    onClick={() =>
                                      setIsOpenPage((prev) => !prev)
                                    }
                                    className={`sm:text-base text-xs font-bold text-center ${getClass(
                                      "text-white",
                                      true
                                    )} h-40px flex flex-1 justify-center items-center cursor-pointer transition-all ${getClass(
                                      "hover:bg-black8"
                                    )}`}>
                                    {item}
                                  </a>
                                </Link>
                              )
                          )}
                          {startPage > 1 && (
                            <div
                              className={`sm:text-base text-xs font-bold text-center ${getClass(
                                "text-white",
                                true
                              )} h-40px flex flex-1 justify-center items-center cursor-pointer transition-all ${getClass(
                                "hover:bg-black8"
                              )}`}>
                              ...
                            </div>
                          )}
                          {startPage > 1 && (
                            <Link
                              prefetch={false}
                              {...itemPropsPage[1]}
                              href={{
                                pathname: router.pathname,
                                query: {
                                  ...router.query,
                                  page: 1,
                                },
                              }}>
                              <a
                                className={`sm:text-base text-xs font-bold text-center ${getClass(
                                  "text-white",
                                  true
                                )} h-40px flex flex-1 justify-center items-center cursor-pointer transition-all hover:bg-black8`}>
                                1
                              </a>
                            </Link>
                          )}

                          <div ref={pageScrollRef} />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              <Link
                prefetch={false}
                href={{
                  pathname: router.pathname,
                  query: {
                    ...router.query,
                    page: nextPage < 1 ? 1 : nextPage,
                  },
                }}>
                <a className="cursor-pointer">
                  <img
                    src={`/icons/${
                      process.env.NEXT_PUBLIC_APP_NAME === "Zoopedia" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "PrefabWorld" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "Parkful" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "WorldCasino" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "Castlepedia" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "LuxResort Club" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "AparthotelClub" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "RooftopClub" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "Cocktayl" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "SpaClub" ||
                      process.env.NEXT_PUBLIC_APP_NAME === "Beachful"
                        ? process.env.NEXT_PUBLIC_APP_NAME?.replace(
                            " ",
                            ""
                          )?.toLowerCase() + "/"
                        : ""
                    }ic_arrow_right.png`}
                    width={isMobileVersion ? 30 : 50}
                    height={isMobileVersion ? 30 : 50}
                    alt="arrow"
                  />
                </a>
              </Link>
            </div>
          )}
        <View style={styles.gap} />
        <LocationModal
          ref={locationModal}
          category={dataCategory}
          locationSelected={locationSelected}
          distanceValue={locationSelected?.distance}
          isDistance
          isCountryOnly={isChartsMode}
          onPressApply={(location, distance) => {
            router.replace({
              query: { ...router.query, page: 1 },
            });
            setLocationSelected({ ...location, distance });
            if (locationModal) {
              locationModal.current.hideModal();
            }
          }}
          onPressCancel={() => {
            if (locationModal) {
              locationModal.current.hideModal();
            }
          }}
        />
        <SingleSelectModal
          ref={sortMenuModal}
          icon={Images.iconSortColored}
          title={t("key_sort")}
          checkedItemId={sortBy}
          items={sortMenu.filter((item) => item.isHide === false)}
          onPressItem={(item) => {
            setSortBy(item.id);
            if (sortMenuModal) {
              sortMenuModal.current.hideModal();
            }
          }}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  background: {
    overflow: "hidden",
    backgroundColor: getClass("background"),
  },
  container: {
    flex: 1,
    alignItems: "center",
  },
  gap: {
    height: 20,
  },
});

export default ExploreSearchScreen;
